import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { SelectInput } from "../../components/common/UI/Inputs/InputControls";
import { myContactsActions, archivedActions } from "../../_store";
import { useSelector, useDispatch } from "react-redux";
import { writeMessageActions, sendPhotosActions } from "../../_store";
import EmojiPicker from "../../components/common/EmojiPicker";
import writeMessageSchema from "../../validation/writeMessageSchema";
import sendPhotoSchema from "../../validation/sendPhotoSchema";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import NotificationService from "../../../src/ui/ui-modal-notification.js";
import { ReactNotifications } from "react-notifications-component";
import useFullPageLoader from "../../hooks/useFullPageLoader.jsx";
import { useNavigate, useLocation } from "react-router-dom";
import useDraft from "../../components/common/autoSaveDraftMsg/useDraft";
import { decryptDataInviteLink } from "../../utils/encryptDecrypt";
import { getGraphemes, restrictCharacters } from "../../utils/keywordBlocker.js";
import translations from '../../config/TranslateFile.jsx'
import EXIF from 'exif-js';
import piexif from "piexifjs";
import fullscreen from "../../assets/images/full-screen.png";
import LanguageToggle from "../../components/header/dropdown/notification.jsx";
import { EventLog, CreateEventLogTextFileForInbox } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import EcardGallery from "../E-card/Ecard_Gallary.jsx";
import GraphemeSplitter from 'grapheme-splitter';
import useCheckQuarantineWords from "../../hooks/useCheckQuarantineWords.jsx";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";
import AlertPopup from "../../components/common/CommonAlert.js";
import { checkEmojiRegex, commonemojiRegex, getDifference } from "../../components/common/emoji-whitelist.js";
// import Marquee from "react-fast-marquee";


const WriteMessage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const subjectInputRef = useRef(null); // Ref for the subject input
  const descInputRef = useRef(null); // Ref for the message input
  const subjectPhotoInputRef = useRef(null); // Ref for the subject input
  const subjectEcardInputRef = useRef(null);
  const [activeTab, setActiveTab] = useState("message");
  const [draftActive, setDraftActive] = useState(false);
  const [isSubjectIconPickerOpen, setIsSubjectIconPickerOpen] = useState(false);
  const [isDescIconPickerOpen, setIsDescIconPickerOpen] = useState(false);
  const [showCreditsAndMessageCost, setShowCreditsAndMessageCost] =
    useState(false);
  const emojiPickerRef = useRef(null);
  const [isSubjectFocused, setIsSubjectFocused] = useState(false);
  const [isMessageFocused, setIsMessageFocused] = useState(false);
  const [errors, setErrors] = useState();
  const [showCODPopup, setShowCODPopup] = useState(false);
  const [SendMessageConfirmation, setSendMessageConfirmation] = useState(false);
  const [IsHasEmojiPermission, setIsHasEmojiPermission] = useState(false);
  const [IsHasMsgEmojiPermission, setIsHasMsgEmojiPermission] = useState(false);
  const [keywordPopup, setKeywordPopup] = useState(false);
  const [foundKeyword, setFoundKeyword] = useState("");
  const [SendPhotoConfirmation, setSendPhotoConfirmation] = useState(false);
  const [SendEcardConfirmation, setSendEcardConfirmation] = useState(false); // Ecard - Confirmation Popup
  const [shouldDisplayHTMLMessage, setShouldDisplayHTMLMessage] =
    useState(false);
  const [isCreditamountModal, setisCreditamountModal] = useState(false);
  const [msgCreditamount, setMsgCreditamount] = useState("");
  const [isDisabledInmateID, setIsDisabledInmateID] = useState(false);
  const [isDisabledMsgInmateID, setIsDisabledMsgInmateID] = useState(false);
  const [paymentMsg, setPaymentMsg] = useState("");
  const [isPaymentMsg, setIsPaymentMsg] = useState(false);
  const [selectedInmate, setSelectedInmate] = useState([]);
  // const MsgPhotoStatusResponse = useSelector(
  //   (state) => state.sendPhotos.CheckingMsgPhotoStatusResponse
  // );
  // Draft Message Emoji Used but emoji permission canceled in Writemessage
  const [sendEmojiRejectPopup, setSendEmojiRejectPopup] = useState(false);
  const [keywords, setKeywords] = useState([]); // State used for store admin restricted keywords
  const LoadQuarantineWords = useCheckQuarantineWords();
  const [isFromDraft, setIsFromDraft] = useState(true);
  const currentLang = translations();
  // PublicUserID - Get from local storage
  const UserID = getStoredValue("userID");
  const [InmateID, setInmateID] = useState(0);
  const { LoadPublicMyContactsDisplay, PublicMyContactsDisplayNew } =
    useSelector((state) => state.myContacts);
  // const { ecardImages } = useSelector((state) => state.WriteMessage);
  const isInsertingFromPicker = useRef(false);
  // const prevValueRef = useRef("");
  const prevValueRef = useRef({
    subject: "",
    message: "",
  });
  const lastKeyRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [showAlert, setShowAlert] = useState(false)
  const maintenanceData = useSelector((state) => state.master.maintenanceMode);
  const {
    handleDraftChange,
    setIsDraftModified,
    clearDraft,
    setIsSaveDraftModified,
  } = useDraft();
  const EcardInmateID = location?.state?.EcardInmateID || "";
  const PhotoInmateID = location.state?.PhotoInmateID || "";
  const NewMessageID = location.state?.newMessageID || "";
  // Initial state for show creditbalance, message and emoji cost
  const initialCreditBalance = {
    CreditBalance: 0.0,
    FacilityEmojiCost: 0.0,
    FacilityID: null,
    FacilityMessageCost: 0.0,
    FacilityPhotoCost: 0.0,
    FacilityEcardCost: 0.0,
    InmateStatus: -1,
    IsEmojiEnabled: false,
  };
  const [EcardFacilityList, setEcardFacilityList] = useState();
  // Initial state for send message
  const initialMessage = {
    userID: UserID,
    inmatesId: 0,
    facilityID: 0,
    sender: "PublicUser",
    receiver: "Inmate",
    subject: "",
    messageBody: "",
    messageCost: 0,
    isReplyMsg: 0,
    replyMessageID: 0,
    isSALoginAsPU: 0,
    creditAccountType: 0,
    taskGUID: "",
    taskNo: 0,
    draftID: 0,
    isEmojiUsed: true,
    messageEmojiCost: 0,
    IsQuarantine: false
  };

  // Inital state for save as draft
  const initialDraft = {
    draftID: 0,
    publicUserId: UserID,
    inmateID: 0,
    subject: "",
    messageBody: "",
    draftFromValue: 3,
    messageID: 0,
    isSALoginAsPU: 0,
    action: 1,
  };

  // Initial state for send Photo
  const initialPhoto = {
    folderPath: "", // Give as empty
    filename: "", //filename.type
    file: "", // base64 data
    fileType: "",
    userID: UserID,
    inmatesId: 0,
    subject: "",
    photoBinaryData: "",
    photoExifInfo: "",
    photoCost: 0,
    browerType: "chrome",
    ipAddress: "192.68.10.164",
    isSALoginAsPU: 0,
    isEmojiUsed: false,
    photoEmojiCost: 0,
    facilityID: 0,
  };

  // Initial State for Ecard
  const initialEcard = {
    folderPath: "",
    filename: "",
    file: "",
    userID: UserID,
    inmatesId: 0,
    facilityId: 0,
    subject: "",
    isEmojiUsed: false,
    totalEmojiCost: 0,
    totalEcardCost: 0,
  };

  // state for load Ecard Images from our IIS Server
  const [ecardImages, setEcardImages] = useState([]);

  // Function used for load all images from local source from assets/ecard folder
  useEffect(() => {
    // Correct relative path based on the component's location
    const images = require.context('../../assets/ECard', false, /\.(png|jpe?g|svg)$/);
    const imagePaths = images.keys().map(image => images(image));
    setEcardImages(imagePaths);
  }, []);

  useEffect(() => {
    const savedDraft = getStoredValue('draft');
    if (savedDraft != null) {
      setIsSaveDraftModified(true);
    }
  }, [setIsSaveDraftModified]);

  // State hooks
  const [creditBalance, setCreditBalance] = useState(initialCreditBalance);
  const [message, setMessage] = useState(initialMessage);
  const [draft, setDraft] = useState(initialDraft);
  const [photo, setPhoto] = useState(initialPhoto);
  const [ecard, setEcard] = useState(initialEcard);
  const [selectedEcard, setSelectedEcard] = useState(null);
  const maxDescriptionLength = 2000;
  const [zoom, setZoom] = useState(1);
  const zoomIn = () => setZoom((prev) => Math.min(prev + 0.8, 4));
  const zoomOut = () => setZoom((prev) => Math.max(prev - 0.8, 1));
  // Photos state
  const [selectedImage, setSelectedImage] = useState(null);
  const [rotation, setRotation] = useState(0);


  // Loads and dispatches the user's contacts for messaging purposes with specified parameters when the component mounts.
  useEffect(() => {
    if (UserID && !PhotoInmateID) {
      if (activeTab === "sendPhoto") {
        const savedDraft = getStoredValue("draft");
        if (savedDraft != null) {
          setIsSaveDraftModified(true);
        }
        dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
        loadInmateDetails("Photo");
        handleForceReset();
      } else if (activeTab === "message") {
        if (!location.state?.MessageTo) {
          dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
          loadInmateDetails("Message");
        } else {
          dispatch(myContactsActions.clearLoadPublicMyContactsDisplay());
          loadInmateDetailsForDraft("Message");
        }
      }
    }

  }, [UserID, dispatch, activeTab]);

  const loadInmateDetails = (Purpose) => {
    const inmatesID = 0;
    const userID = UserID; // Ensure UserID is correctly retrieved from state or props
    const ActiveStatus = 2;
    const SortField = "InmateName asc";
    const InmateLoadPurpose = Purpose || "Message";
    dispatch(
      myContactsActions.LoadPublicMyContactsDisplay({
        userID,
        inmatesID,
        InmateLoadPurpose,
        ActiveStatus,
        SortField,
      })
    );
  };

  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    return () => {
      document.body.style.overflow = "auto"; // Cleanup on unmount
    };
  }, []);


  // Ecard Enable Facility 
  useEffect(() => {
    if (maintenanceData?.EcardAlert !== 1) return;
    if (location.state?.isEcardtoBack === true) return;


    const data = {
      publicUserID: UserID,
      inmateID: 0,
      connectionStatus: 2,
      purpose: "Ecard",
      sortBy: "",
    };

    dispatch(writeMessageActions.LoadPublicMyContactsDisplayEcard(data))
      .unwrap()
      .then((payload) => {
        if (!payload || payload.length === 0) {
          setEcardFacilityList([]);
          return;
        }

        // Create copy before sorting
        const sorted = [...payload].sort((a, b) =>
          a.FacilityName.localeCompare(b.FacilityName)
        );

        // Extract unique facility names
        const facilityNames = [...new Set(sorted.map((x) => x.FacilityName))];

        setEcardFacilityList(facilityNames);

        if (facilityNames.length > 0) {
          setShowAlert(true);
        }
      })
      .catch(() => {
        setEcardFacilityList([]);
      });

  }, [maintenanceData?.EcardAlert, location.state?.isEcardtoBack, UserID, dispatch]);


  ///

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
    if (location.state?.isshowalert) {
      setPaymentMsg(currentLang?.ECardPopContent?.Unavailable_ECard);
      setIsPaymentMsg(true);
    }
  }, [location.state]);

  // Disabled Inmate access load for Draft
  const loadInmateDetailsForDraft = (Purpose) => {
    const inmatesId = 0;
    const userId = UserID;
    const activeStatus = 2;
    const sortField = "InmateName asc";
    const inmateLoadPurpose = Purpose || "Message";
    dispatch(
      myContactsActions.PublicMyContactsDisplayNew({
        userId,
        inmatesId,
        inmateLoadPurpose,
        activeStatus,
        sortField,
      })
    );
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if ([...searchParams.keys()].length > 0) {
      const inviteLink = searchParams.get("InviteLink");
      if (inviteLink !== null && inviteLink.trim() !== "") {
        setMessage((prev) => ({
          ...prev,
          inmatesId: 0, // Clear the specific field error
        }));
        const decodedInviteLink = decryptDataInviteLink(
          decodeURIComponent(inviteLink.trim())
        );
        if (decodedInviteLink == "") {
          return;
        }
        const inviteLinkInfo = decodedInviteLink.split("&");
        // Assuming the first part is InmateID and the second part is InviteGUID
        const inmateID = inviteLinkInfo[0];
        const inviteGUID = inviteLinkInfo[1];
        setMessage((prev) => ({
          ...prev,
          inmatesId: parseInt(inmateID), // Clear the specific field error
        }));
        if (message.inmatesId !== 0 && message.inmatesId !== null) {
          if (Array.isArray(LoadPublicMyContactsDisplay)) {
            const filteredContacts = LoadPublicMyContactsDisplay.filter(
              (item) => item.value === parseInt(inmateID)
            );
            if (filteredContacts.length === 1) {
              const data = filteredContacts[0];
              handleSelectChange(data, "inmatesId", false);
              setIsDisabledMsgInmateID(true);
            }
          }
          setIsDisabledMsgInmateID(true);
        }
      }
    }
  }, [location, LoadPublicMyContactsDisplay, message.inmatesId]);

  // Purchase Credit Status
  // useEffect(() => {
  //   if (MsgPhotoStatusResponse) {
  //     const { Result, Notes } = MsgPhotoStatusResponse;
  //     switch (Result) {
  //       case -7:
  //         setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked);
  //         setIsPaymentMsg(true);
  //         if (activeTab == "sendPhoto") {
  //           handlePhotoReset();
  //         } else if (activeTab == "message") {
  //           handleForceReset();
  //         }
  //         dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
  //         break;
  //       case -8:
  //         setPaymentMsg(currentLang?.ArchivedPagePopContent?.No_longer_connected);
  //         setIsPaymentMsg(true);
  //         if (activeTab == "sendPhoto") {
  //           handlePhotoReset();
  //         } else if (activeTab == "message") {
  //           handleForceReset();
  //         }
  //         dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
  //         break;
  //       case -6:
  //         setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Contact);
  //         setIsPaymentMsg(true);
  //         if (activeTab == "sendPhoto") {
  //           handlePhotoReset();
  //         } else if (activeTab == "message") {
  //           handleForceReset();
  //         }
  //         dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
  //         break;
  //       case -4:
  //         setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Facility);
  //         setIsPaymentMsg(true);
  //         if (activeTab == "sendPhoto") {
  //           handlePhotoReset();
  //         } else if (activeTab == "message") {
  //           handleForceReset();
  //         } else {
  //           handleEcardReset();
  //         }
  //         dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
  //         break;
  //       case -3:
  //         setPaymentMsg(Notes);
  //         setIsPaymentMsg(true);
  //         if (activeTab == "sendPhoto") {
  //           handlePhotoReset();
  //         } else if (activeTab == "message") {
  //           handleForceReset();
  //         }
  //         dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
  //         break;
  //       default:
  //         if (Result === 0) {
  //           // If success response (result = 0), redirect
  //           setStoredValue("InmateID", InmateID);
  //           navigate("/public/PurchaseCredits", {
  //             state: { previousPath: location.pathname },
  //           });
  //           storeCurrentRoute("/public/PurchaseCredits");
  //           dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
  //         }
  //         break;
  //     }
  //     setisCreditamountModal(false);
  //   }
  // }, [MsgPhotoStatusResponse]);

  // Removes the "border-danger" class from the specified field to clear validation styling, if it exists.
  const removeFieldValidationByName = (fieldName) => {
    const field = document.querySelector(`[name="${fieldName}"]`);
    if (field && field.classList.contains("border-danger")) {
      field.classList.remove("border-danger");
    }
  };


  const findGraphemeClusters = (input) => {
    const splitter = new GraphemeSplitter();
    const graphemes = splitter.splitGraphemes(input);
    let index = 0;
    const segments = graphemes.map(grapheme => {
      const segmentInfo = {
        segment: grapheme,
        index: index,
        input: input
      };
      index += grapheme.length;
      return segmentInfo;
    });

    return segments;
  };

  const handleInputClick = (e) => {
    const { target } = e;
    const inputValue = target.value;
    const caretPosition = target.selectionStart;
    const graphemes = findGraphemeClusters(inputValue);
    let graphemeIndex = 0;
    for (let i = 0; i < graphemes.length; i++) {
      if (graphemes[graphemes.length - 1].index < caretPosition) {
        graphemeIndex = caretPosition;
        break;
      }
      else if (graphemes[i].index == caretPosition) {
        graphemeIndex = i;
        break;
      }
    }
    setCursorPosition(graphemeIndex);
  };

  // Handles input changes for each field by clearing validation errors, updating the message state, and ensuring the message body field respects the maximum length with emojis counted as single units.
  const handleChange = (e, isMessage) => {
    let { name, value } = e.target;
    const prevValue = prevValueRef.current[name == "messageBody" ? "message" : "subject"];
    const currentAddValue = getDifference(value, prevValue);

    let chars = getGraphemes(currentAddValue);
    // Mobile Emoji Removed
    if (chars?.length === 1 && currentAddValue.match(emojiRegex)) {
      return;
    }
    // Get the last character typed
    // if (!isInsertingFromPicker.current && wasAdded) {
    //   const graphemes = getGraphemes(value);
    //   const lastChar = graphemes[graphemes.length - 1];

    //   // If the last character is an emoji, remove it
    //   if (isEmoji(lastChar)) {
    //     value = graphemes.slice(0, -1).join(""); // Remove last emoji
    //   }
    // }
    //prevValueRef.current = value;
    prevValueRef.current[name == "messageBody" ? "message" : "subject"] = value;

    removeFieldValidationByName(name);

    setErrors((prev) => ({
      ...prev,
      [name]: "", // Clear the specific field error
    }));

    if (name === "messageBody") {
      // Check if the length with emojis counted as single units is within the limit
      if (getDisplayLength(value) <= maxDescriptionLength) {
        setMessage((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        if (isMessage) {
          handleDraftChange("messageBody", value);
          setIsDraftModified(true);
        }
      }
    } else {
      // value = value.trimStart();
      // value = value.replace(/\s+/g, " ");
      if (getDisplayLength(value) <= 50) {
        setMessage((prevState) => ({
          ...prevState,
          [name]: value,
        }));

        if (isMessage) {
          handleDraftChange("subject", value);
          setIsDraftModified(true);
        }
        setPhoto((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        setEcard((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  };

  // Formats a given value to two decimal places, ensuring it is treated as a number.
  const formatToTwoDecimals = (value) => {
    // Ensure the value is a number before calling toFixed
    return (typeof value === "number" ? value : parseFloat(value)).toFixed(2);
  };

  // Known compound emojis that require special handling
  const compoundEmojis = ["🤷‍♀️", "🤷‍♂️"];

  // Regex to match both single emojis and compound emojis with ZWJ
  // const emojiRegex =  /(\p{Extended_Pictographic}(\u200D\p{Extended_Pictographic})*)/gu;
  const emojiRegex = commonemojiRegex();


  // Function to count emojis as single units and other characters normally
  const getDisplayLength = useCallback(
    (text) => {
      // Count compound emojis explicitly
      let compoundEmojiCount = 0;
      compoundEmojis.forEach((emoji) => {
        const compoundRegex = new RegExp(emoji, "g");
        const match = text.match(compoundRegex);
        if (match) {
          compoundEmojiCount += match.length;
          // Remove matched compound emojis from text to prevent double-counting
          text = text.replace(compoundRegex, "");
        }
      });

      // Count remaining emojis with regex
      const matches = text.match(emojiRegex);
      let emojiCount = matches ? matches.length : 0;

      // Calculate non-emoji characters
      let nonEmojiText = text.replace(emojiRegex, "").normalize("NFC").trim();
      let nonEmojiCount = nonEmojiText.length;

      // Total count: compound emojis + other emojis + non-emoji characters
      return compoundEmojiCount + emojiCount + nonEmojiCount;
    },
    [] // Add any dependencies required
  );

  const handleKeyDown = (event) => {
    // if (event.key === "Enter") {
    //   event.preventDefault();
    //   handleMessageSend();
    // }
    lastKeyRef.current = event.key; // store the last pressed key
    if (event.key === "Meta") {
      // setDisableInput(true); // Disable input while the Windows key is held
      event.target.blur();
    }
  };

  const handleKeyDownPhoto = (event) => {
    lastKeyRef.current = event.key; // store the last pressed key
    if (event.key === "Enter") {
      event.preventDefault();
      handlePhotoSendValidation();
    }
    if (event.key === "Meta") {
      // setDisableInput(true); // Disable input while the Windows key is held
      event.target.blur();
    }
  };

  const handleKeyUp = () => {
    // setDisableInput(false); // Re-enable input when the key is released
  };

  // Inmate Name Selectbox - onChange event
  const handleSelectChange = (selectedOption, fieldName, isPhoto) => {
    setShowCreditsAndMessageCost(true);
    setErrors((prev) => ({
      ...prev,
      [fieldName]: "", // Clear the specific field error
    }));
    const selectedValue = Array.isArray(selectedOption)
      ? selectedOption.map((option) => option.value)
      : selectedOption?.value ?? "";
    setMessage((prevState) => ({
      ...prevState,
      [fieldName]: selectedValue,
    }));

    if (selectedValue !== "") {
      const InmateLoadedDetails =
        LoadPublicMyContactsDisplay !== null &&
          LoadPublicMyContactsDisplay?.length !== undefined
          ? LoadPublicMyContactsDisplay !== null &&
            LoadPublicMyContactsDisplay?.length !== undefined &&
            LoadPublicMyContactsDisplay.length === 0
            ? PublicMyContactsDisplayNew
            : LoadPublicMyContactsDisplay
          : PublicMyContactsDisplayNew;
      let selectInmate = InmateLoadedDetails?.filter((item) => {
        return item?.value === selectedValue;
      });
      setSelectedInmate(selectInmate);
      setInmateID(parseInt(selectedValue));
      let userID = selectInmate[0]?.PublicUserID;
      setMessage((prevState) => ({
        ...prevState,
        userID: userID,
      }));
      let inmatesId = selectInmate[0]?.InmateID;
      // assign Inmates ID & Public UserID to Draft State
      setDraft((prevState) => ({
        ...prevState,
        inmateID: inmatesId,
      }));

      setPhoto((prevState) => ({
        ...prevState,
        inmatesId: inmatesId,
      }));
      setEcard((prevState) => ({
        ...prevState,
        inmatesId: inmatesId,
      }));
      dispatch(
        writeMessageActions.getCreditBalance({
          userId: userID,
          inmatesId: inmatesId,
        })
      ).then((response) => {
        if (response?.meta?.requestStatus === "fulfilled") {
          // The action was successful
          setShowCreditsAndMessageCost(true);
          let data = response?.payload;
          const formattedBalance = Object.keys(data).reduce((acc, key) => {
            acc[key] =
              typeof response?.payload[key] === "number" ||
                !isNaN(response?.payload[key])
                ? formatToTwoDecimals(response?.payload[key])
                : response.payload[key];
            return acc;
          }, {});

          let formatValue = formattedBalance[0];
          if (activeTab === "ecard") {
            let data = {
              messageKeyword: "",
              facilityID: formatValue?.FacilityID,
              webUserSentAction: "",
              inmateSentAction: "",
              keyWordFilterType: "",
              activeStatus: 2,
              pageNo: 1,
              rowCountPerPage: 50,
              sortBy: "MessageKeyWord Desc"
            };
            dispatch(
              writeMessageActions.LoadKeywordList(data)
            ).then((response) => {
              setKeywords(response?.payload?.DataList);
            })
          }
          if (isPhoto && formatValue?.CreditBalance === 0) {
            setisCreditamountModal(true);
            setMsgCreditamount(
              activeTab === "ecard"
                ? currentLang?.ECardPopContent?.Low_balance_Card
                : currentLang?.ECardPopContent?.Low_balance_Photo
            );
          }
          if (
            isPhoto &&
            formatValue?.CreditBalance < formatValue?.FacilityPhotoCost
          ) {
            setisCreditamountModal(true);
            setMsgCreditamount(
              activeTab === "ecard"
                ? currentLang?.ECardPopContent?.Low_balance_Card
                : currentLang?.ECardPopContent?.Low_balance_Photo
            );
          }
          if (!isPhoto) {
            handleDraftChange("inmateID", selectedValue);
          }
          setCreditBalance({
            ...formatValue,
            CreditBalance: parseFloat(formatValue?.CreditBalance ?? 0),
            FacilityEmojiCost: parseFloat(
              formatValue?.IsEmojiEnabled
                ? formatValue?.FacilityEmojiCost ?? 0
                : 0
            ),
            FacilityMessageCost: parseFloat(
              formatValue?.FacilityMessageCost ?? 0
            ),
            FacilityPhotoCost: parseFloat(formatValue?.FacilityPhotoCost ?? 0),
            FacilityEcardCost: parseFloat(formatValue?.FacilityEcardCost ?? 0),
            IsEmojiEnabled: formatValue?.IsEmojiEnabled ?? false,
          });
        } else {
          // The action failed
          // console.error("Error:", response.error.message);
        }
      });
    } else {
      setShowCreditsAndMessageCost(false);
      setCreditBalance((prevState) => ({
        ...prevState,
        IsEmojiEnabled: false,
      }));
      setIsDescIconPickerOpen(false);
      setIsSubjectIconPickerOpen(false);
      setDraft((prevState) => ({
        ...prevState,
        inmateID: 0,
      }));

      setPhoto((prevState) => ({
        ...prevState,
        inmatesId: 0,
      }));
      setEcard((prevState) => ({
        ...prevState,
        inmatesId: 0,
      }));
      if (!isPhoto) {
        handleDraftChange("inmateID", 0);
      }
    }
  };

  // Toggles the visibility of the emoji picker for either the subject or message body fields, ensuring only one picker is open at a time and setting focus to the relevant input.
  const handleIconClick = (field) => {
    if (field === "subject") {
      setIsSubjectIconPickerOpen((prevState) => !prevState);
      setIsDescIconPickerOpen(false);
      if (activeTab === "message") {
        subjectInputRef?.current?.focus();
      } else if (activeTab === "sendPhoto") {
        subjectPhotoInputRef?.current?.focus();
      } else {
        subjectEcardInputRef?.current?.focus();
      }
    } else if (field === "messageBody") {
      setIsDescIconPickerOpen((prevState) => !prevState);
      setIsSubjectIconPickerOpen(false);
      descInputRef.current.focus();
    }
  };

  // Handles emoji selection, appends it to the specified field within max length, and focuses the corresponding input field.
  const handleEmojiSelect = (emoji, field) => {
    const maxLength = field === "messageBody" ? 2000 : 50; // Define the max length for each field

    isInsertingFromPicker.current = true;
    const insertAtCaret = (text, emoji, inputRef) => {
      const input = inputRef.current;
      input.focus();
      const start = input.selectionStart;
      const end = input.selectionEnd;

      // Insert the emoji at the caret position
      const newText = text.slice(0, start) + emoji + text.slice(end);
      // Move the caret position after the emoji
      // setTimeout(() => {
      //   input.selectionStart = input.selectionEnd = start + emoji.length;
      // }, 0);
      requestAnimationFrame(() => {
        input.selectionStart = input.selectionEnd = start + emoji.length;
      });

      return newText;

    };

    if (activeTab === "message") {
      setMessage((prevState) => {
        const inputRef =
          field === "messageBody" ? descInputRef : subjectInputRef;
        const newValue = insertAtCaret(prevState[field], emoji, inputRef);
        // prevValueRef.current = newValue;
        prevValueRef.current[field == "messageBody" ? "message" : "subject"] = newValue;
        // const newValue = prevState[field] + emoji; // Add emoji to the specified field

        // Ensure that the field value does not exceed the maximum length
        if (getDisplayLength(newValue) <= maxLength) {
          if (field == "messageBody") {
            handleDraftChange("messageBody", newValue);
            handleDraftChange("draftFromValue", 3);
          } else {
            handleDraftChange("subject", newValue);
            handleDraftChange("draftFromValue", 3);
          }
          return {
            ...prevState,
            [field]: newValue,
          };
        }

        // If the value exceeds the maxLength, return the previous state
        return prevState;
      });
    } else {
      setPhoto((prevState) => {
        // const newValue = prevState[field] + emoji; // Add emoji to the specified field
        const inputRef =
          field === "messageBody" ? descInputRef : subjectPhotoInputRef;
        const newValue = insertAtCaret(prevState[field], emoji, inputRef);
        // Ensure that the field value does not exceed the maximum length
        if (getDisplayLength(newValue) <= maxLength) {
          return {
            ...prevState,
            [field]: newValue,
          };
        }

        // If the value exceeds the maxLength, return the previous state
        return prevState;
      });
    }

    // Focus the appropriate input field after adding the emoji
    if (field === "subject") {
      if (activeTab === "message") {
        subjectInputRef.current.focus();
      } else {
        subjectPhotoInputRef.current.focus();
      }
    } else if (field === "messageBody") {
      descInputRef.current.focus();
    }
    setTimeout(() => {
      isInsertingFromPicker.current = false;
    }, 100);
  };

  const handleSubjectFocus = () => {
    setIsSubjectFocused(true);
  };

  const handleSubjectBlur = (e) => {
    // Check if the blur event is triggered by the emoji picker
    if (
      emojiPickerRef.current &&
      emojiPickerRef.current.contains(e.relatedTarget)
    ) {
      return; // Don't close the emoji picker if the click is inside it
    }

    setIsSubjectFocused(false);
    // setIsSubjectIconPickerOpen(false); // Close the emoji picker
  };

  const handleMessageFocus = () => {
    setIsMessageFocused(true);
  };

  const handleMessageBlur = (e) => {
    if (
      emojiPickerRef.current &&
      emojiPickerRef.current.contains(e.relatedTarget)
    ) {
      return; // Don't close the emoji picker if the click is inside it
    }
    setIsMessageFocused(false);
    // setIsDescIconPickerOpen(false);
  };

  // Emoji Select functionality for Photo Tab
  const handleEmojiSelectPhoto = (emoji, field) => {
    const maxLength = field === "messageBody" ? 2000 : 50; // Define the max length for each field

    const insertAtCaret = (text, emoji, inputRef) => {
      const input = inputRef.current;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      // Insert the emoji at the caret position
      const newText = text.slice(0, start) + emoji + text.slice(end);
      prevValueRef.current[field == "messageBody" ? "message" : "subject"] = newText;
      // prevValueRef.current = newText;
      // Move the caret position after the emoji
      setTimeout(() => {
        input.selectionStart = input.selectionEnd = start + emoji.length;
      }, 0);

      return newText;
    };

    setPhoto((prevState) => {
      // const newValue = prevState[field] + emoji; // Add emoji to the specified field
      const inputRef = subjectPhotoInputRef;

      const newValue = insertAtCaret(prevState[field], emoji, inputRef);
      // Ensure that the field value does not exceed the maximum length
      if (getDisplayLength(newValue) <= maxLength) {
        return {
          ...prevState,
          [field]: newValue,
        };
      }
      // If the value exceeds the maxLength, return the previous state
      return prevState;
    });
    // Focus the appropriate input field after adding the emoji
    if (field === "subject") {
      subjectPhotoInputRef?.current?.focus();
    }
  };


  // Function used for calculate message cost and emoji cost
  const calculateMessageCost = useCallback(
    (message, FacilityEmojiCost, FacilityMessageCost) => {

      // Track unique emojis in a Set for simplicity
      const uniqueEmojis = new Set();
      const matches = checkEmojiRegex(message);
      if (matches) {
        matches.forEach((emoji) => uniqueEmojis.add(emoji));
      }

      // Calculate costs
      const emojiCostTotal = uniqueEmojis.size * (FacilityEmojiCost || 0);
      const messageCost = FacilityMessageCost || 0;
      const totalCost = messageCost + emojiCostTotal;

      // Set state with formatted cost values
      setMessage((prevState) => ({
        ...prevState,
        messageCost: totalCost.toFixed(2),
        messageEmojiCost: emojiCostTotal.toFixed(2),
        isEmojiUsed: emojiCostTotal > 0 ? true : false,
      }));
    },
    [creditBalance, setMessage]
  );

  const calculatePhotoCost = useCallback(
    (message, FacilityPhotoCost, FacilityEmojiCost) => {

      const uniqueEmojis = new Set();
      const matches = checkEmojiRegex(message);
      if (matches) {
        matches.forEach((emoji) => uniqueEmojis.add(emoji));
      }

      // Calculate costs
      const emojiCostTotal = uniqueEmojis.size * (FacilityEmojiCost || 0);
      const photoCost = FacilityPhotoCost || 0;
      const totalCost = photoCost + emojiCostTotal;

      // Set state with formatted cost values
      setPhoto((prevState) => ({
        ...prevState,
        photoCost: totalCost.toFixed(2),
        photoEmojiCost: emojiCostTotal.toFixed(2),
        isEmojiUsed: emojiCostTotal > 0 ? true : false,
      }));
    },
    [creditBalance, setPhoto]
  );

  // Validates message fields, clears validation errors, and sets confirmation flags if no errors exist, calculating the message cost.
  const handleMessageSend = async (e) => {
    e?.preventDefault();
    setErrors({});
    if (document?.getElementsByClassName("border-danger").length !== 0) {
      document
        .querySelectorAll(".border-danger")
        .forEach((el) => el.classList.remove("border-danger"));
    }
    const { error } = writeMessageSchema(message);
    if (error?.details) {
      error.details.map((e) => {
        const { path } = e;

        // Update the errors state
        setErrors((prev) => ({
          ...prev,
          [path[0]]: e.message,
        }));

        // Select both input and textarea elements by name
        document
          .querySelector(`input[name=${path[0]}], textarea[name=${path[0]}]`)
          ?.classList.add("border-danger");
      });
      return;
    } else {

      const inmatesID = message.inmatesId;
      const userID = parseInt(UserID);
      dispatch(
        myContactsActions.PublicCreditBalance({
          userID,
          inmatesID,
        })
      ).then(async (response) => {
        const formatValue = response.payload[0];
        setCreditBalance({
          ...formatValue,
          CreditBalance: parseFloat(
            formatValue?.CreditBalance ? formatValue?.CreditBalance : 0
          ),
          FacilityEmojiCost: parseFloat(
            formatValue?.IsEmojiEnabled ? formatValue?.FacilityEmojiCost : 0
          ),
          FacilityMessageCost: parseFloat(
            formatValue?.FacilityMessageCost
              ? formatValue?.FacilityMessageCost
              : 0
          ),
          FacilityPhotoCost: parseFloat(
            formatValue?.FacilityPhotoCost ? formatValue?.FacilityPhotoCost : 0
          ),
          FacilityEcardCost: parseFloat(
            formatValue?.FacilityEcardCost ? formatValue?.FacilityEcardCost : 0
          ),
          IsEmojiEnabled: formatValue?.IsEmojiEnabled ? true : false,
        });

        //  check for restricted keywords
        const isAllowed = await checkRestrictedKeywords(message?.messageBody + ' ' + message?.subject, formatValue?.FacilityID);
        setMessage({ ...message, IsQuarantine: !isAllowed ? true : false })

        // if (!isAllowed) return;

        if (
          (containsEmojis(message?.subject) ||
            containsEmojis(message?.messageBody)) && formatValue !== undefined &&
          !formatValue?.IsEmojiEnabled
        ) {
          setSendEmojiRejectPopup(true);
        } else {
          setSendEmojiRejectPopup(false);
          setSendMessageConfirmation(true);
          setShouldDisplayHTMLMessage(true);
          let text = message?.subject + message?.messageBody;
          // const message = "Hello 😏😏👨‍👩‍👧‍👦👨‍👩‍👧‍👦👨‍👩‍👧‍👦";
          calculateMessageCost(
            text,
            formatValue?.FacilityEmojiCost,
            formatValue?.FacilityMessageCost
          );

          // Event Log for Write Message - Send Message button Confirmation 
          const infoMessage = 'Write Message/ Photo Menu - Send Message button clicked in Write Message Tab, confirmation popup displayed (Yes/No)';
          const redirectURL = '---';
          const Response = 'Shows YES or NO popup to confirm the action';
          const Status = '---';
          CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status)
        }
      });
    }
  };


  const checkRestrictedKeywords = async (subject, facilityID) => {
    var result = await LoadQuarantineWords(subject, facilityID)
    if (result?.isQuarantineWords) {
      // const restrictionMessage = `Your message contains restricted word(s): "${result?.keywordList}". Please remove the word and try again.`;
      // setFoundKeyword(restrictionMessage);
      // setKeywordPopup(true);
      return false; //
    }
    else {
      setKeywordPopup(false);
      return true; // ✅ Proceed
    }
  };

  const containsEmojis = (str) => {
    // Matches emojis including `⭐` with or without variation selector
    const emojiRegex =
      /(?:[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{2B50}\u{FE0F}]|[\u{2B55}])/gu;

    return emojiRegex.test(str);
  };

  // Handle Photo send
  const handlePhotoSendValidation = (e) => {
    e?.preventDefault();
    setErrors({});
    if (document?.getElementsByClassName("border-danger").length == 0) {
      document
        .querySelectorAll(".border-danger")
        .forEach((el) => el.classList.remove("border-danger"));
    }
    const { error } = sendPhotoSchema(photo);
    if (error?.details) {
      error.details.map((e) => {
        const { path } = e;
        // Update the errors state
        setErrors((prev) => ({
          ...prev,
          [path[0]]: e.message,
        }));

        // Select both input and textarea elements by name
        document
          .querySelector(`input[name=${path[0]}]`)
          ?.classList.add("border-danger");
      });
      return;
    } else {
      //extractExifInfo();
      showLoader();
      const inmatesID = photo.inmatesId;
      const userID = UserID; // Ensure UserID is correctly retrieved from state or props
      const ActiveStatus = 2;
      const SortField = "";
      const InmateLoadPurpose = "Photo";
      dispatch(
        myContactsActions.LoadPublicInmateByID({
          userID,
          inmatesID,
          InmateLoadPurpose,
          ActiveStatus,
          SortField,
        })
      ).then(async (response) => {
        const formatValue = response.payload[0];
        setCreditBalance({
          ...formatValue,
          CreditBalance: parseFloat(formatValue?.CreditBalance === undefined ? 0.00 : formatValue.CreditBalance),
          FacilityEmojiCost: parseFloat(
            formatValue?.IsEmojiEnabled ? formatValue?.FacilityEmojiCost === undefined ? 0.00 : formatValue?.FacilityEmojiCost : 0
          ),
          FacilityMessageCost: parseFloat(formatValue?.FacilityMessageCost === undefined ? 0.00 : formatValue.FacilityMessageCost),
          FacilityPhotoCost: parseFloat(formatValue?.FacilityPhotoCost === undefined ? 0.00 : formatValue.FacilityPhotoCost),
          FacilityEcardCost: parseFloat(formatValue?.FacilityEcardCost === undefined ? 0.00 : formatValue.FacilityEcardCost),
          IsEmojiEnabled: formatValue?.IsEmojiEnabled === 1 ? true : false,
        });
        hideLoader();

        //  check for restricted keywords
        // const isAllowed = await checkRestrictedKeywords(photo?.subject, formatValue?.facilityID);
        //if (!isAllowed) return;

        setPhoto((prevState) => ({
          ...prevState,
          ["facilityID"]: formatValue?.facilityID,
        }));
        if (
          containsEmojis(photo?.subject) &&
          formatValue?.IsEmojiEnabled === 0
        ) {
          setSendEmojiRejectPopup(true);
        } else {
          setIsHasEmojiPermission(false);
          setSendPhotoConfirmation(true);
          setShouldDisplayHTMLMessage(true);
          //}
          let text = photo?.subject;
          // const message = "Hello 😏😏👨‍👩‍👧‍👦👨‍👩‍👧‍👦👨‍👩‍👧‍👦";
          const costDetails = calculatePhotoCost(
            text,
            formatValue?.FacilityPhotoCost,
            formatValue?.FacilityEmojiCost
          );

          const infoMessage = 'Write Message/ Photo Menu - Send button clicked in Photo Tab, confirmation popup displayed (Yes/No)';
          const redirectURL = '---';
          const Response = 'Shows YES or NO popup to confirm the action';
          const Status = '---';
          CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status)
        }
      });
    }
  };

  // Confirms message sending, shows a loader, dispatches the message action, and displays notifications based on the response status.
  const handleMessageSentConfirm = () => {
    setSendPhotoConfirmation(false);
    setSendMessageConfirmation(false);
    showLoader();
    const updatedMessage = {
      ...message, // Copy the current state
      draftID: draft?.draftID, // Update only the draftID
      userID: parseInt(UserID),
    };
    const startTime = performance.now();
    dispatch(
      writeMessageActions.InsertUpdateMessageCommunicationSent(updatedMessage)
    ).then((response) => {
      const endTime = performance.now();
      const executionTimeInSeconds = (endTime - startTime) / 1000;

      const infoMessage = `Sent New message to Inmate (Inmate ID - ${message?.inmatesId})`;
      const redirectURL = '---';
      const Response = `Execution Time -  ${executionTimeInSeconds.toFixed(2)} seconds, Sent Message Subject: ${message?.subject}, Sent Message Body: ${message?.messageBody}  ` + JSON.stringify(selectedInmate);
      let Status = '---';


      if (response?.meta?.requestStatus === "fulfilled") {
        hideLoader();
        prevValueRef.current = { subject: "", message: "" };
        let status = response?.payload;
        updatedMessage.result = response?.payload
        dispatch(writeMessageActions?.LoadSendNotificationandEmail(updatedMessage));
        switch (status) {
          case -1:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.Msg_Send_Failed,
              type: "warning",
            });
            Status = "Message sent Failed";
            break;
          case -2:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.Repeated_Msg,
              type: "warning",
            });
            Status = "Repeated Message Conversation";
            handleForceReset();
            break;
          case -3:
          case -5:
            setPaymentMsg(currentLang?.InboxPopContent?.connection_Blocked);
            Status = "Connection is blocked/rejected";
            setIsPaymentMsg(true);
            handleForceReset();
            break;
          case -6:
            // setPaymentMsg(
            //   "The Permission to send Message to this contact has been restricted. "
            // );
            setPaymentMsg(currentLang?.InboxPopContent?.No_Permission);
            setIsPaymentMsg(true);
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Message");
            Status = "The Permission to send Message to this contact has been restricted. ";
            handleForceReset();

            break;
          case -7:
            // setPaymentMsg(
            //   "The Permission to send Message to this contact has been restricted. "
            // );
            setPaymentMsg(currentLang?.InboxPopContent?.connection_Blocked);
            setIsPaymentMsg(true);
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Message");
            Status = "Connection is blocked/rejected";
            handleForceReset();

            break;
          case -8:
            setPaymentMsg(currentLang?.InboxPopContent?.No_longer_connected);
            setIsPaymentMsg(true);
            Status = "You are no longer connected with this user.";
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Message");
            handleForceReset();
            break;
          case -9:
            NotificationService({
              title: currentLang?.Message,
              // message: "This message will be sent as COD.  It cannot be opened until credits are purchased or if the inmate chooses to use one of their free credits.",
              message: currentLang?.InboxPopContent?.Message_Send_Success,
              type: "success",
            });
            Status = "This message will be sent as COD.  It cannot be opened until credits are purchased or if the inmate chooses to use one of their free credits.";
            handleForceReset();
            if (location?.state?.DraftID) {
              const publicUserId = getStoredValue("userID");
              dispatch(
                archivedActions.PULoginUnreadNotificationCount({
                  publicUserId,
                })
              );
            }
            // dispatch(
            //   inboxActions.LoadInboxMessages({
            //     ...defaultInboxParams,
            //     pageNo: 1,
            //   })
            // );
            setisCreditamountModal(true);
            setMsgCreditamount(currentLang?.InboxPopContent?.Send_COD_Msg);
            Status = "This message will be sent as COD.  It cannot be opened until credits are purchased or if the inmate chooses to use one of their free credits..";
            const searchParams = new URLSearchParams(location.search);
            if ([...searchParams.keys()].length > 0) {
              navigate("/public/WriteMessage");
              storeCurrentRoute("/public/WriteMessage");
            }
            break;
          default:
            if (status > 0) {
              if (creditBalance?.CreditBalance === 0) {
                setShowCODPopup(true);
              }
              NotificationService({
                title: currentLang?.Success,
                message: currentLang?.InboxPopContent?.Message_Send_Success,
                type: "success",
              });
              Status = "Message sent successfully";
              handleForceReset();
              const searchParams = new URLSearchParams(location.search);
              if ([...searchParams.keys()].length > 0) {
                navigate("/public/WriteMessage");
                storeCurrentRoute("/public/WriteMessage");
              }
            }
            break;
        }
      }

      CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status)
    });
  };

  // Cancels the message send action by resetting the send confirmation state.
  const handleCancelMessage = () => {
    setSendMessageConfirmation(false);
    setSendPhotoConfirmation(false);
  };

  // Handles saving the message as a draft by validating the message body, updating the draft state, and dispatching the draft action, with appropriate notifications based on the response status.
  const handleSaveasDraft = (e) => {
    e?.preventDefault();
    // Update the draft state and run validation/dispatch after the state is set
    setDraft((prevState) => {
      const updatedDraft = {
        ...prevState,
        subject: message.subject,
        messageBody: message.messageBody,
      };

      setErrors({});
      document
        .querySelectorAll(".border-danger")
        .forEach((el) => el.classList.remove("border-danger"));

      // Validate only the messageBody field in updatedDraft
      const { error } = writeMessageSchema({
        messageBody: updatedDraft.messageBody,
      });

      // Filter and handle only messageBody errors
      const messageBodyError = error?.details?.find(
        (e) => e.path[0] === "messageBody"
      );
      if (messageBodyError) {
        setErrors({ messageBody: messageBodyError.message });
        document
          .querySelector("textarea[name='messageBody']")
          ?.classList.add("border-danger");
        return updatedDraft;
      }

      // Proceed if there are no validation errors
      showLoader();
      setDraftActive(true);
      // Dispatch draft message action with updated draft
      if (draft?.draftID === 0) {
        setIsFromDraft(false);  // False when Draft 
      }

      dispatch(writeMessageActions.DraftMessageCUD(updatedDraft)).then(
        (response) => {
          hideLoader();
          if (response?.meta?.requestStatus === "fulfilled") {
            const status = response?.payload[0]?.ReturnStatus;
            let draftno = response?.payload[0]?.ReturnDraft;
            setDraft((prevState) => ({
              ...prevState,
              draftID: draftno,
            }));
            setDraftActive(false);

            // Save As Draft - EventLog Handlling 
            CreateEventLogTextFileForInbox(
              dispatch,
              "Write Message Menu - Clicked Save As Draft button",
              "---",
              status,
              status === 1 ? "Draft saved successfully" : "Draft updated successfully"
            );
            //          setDraft((prevState) => {
            //   const updatedDraft = {
            //     ...prevState,
            //     subject: message.subject,
            //     messageBody: message.messageBody,
            //   };
            // })
            switch (status) {
              case 1:
                setDraftActive(false);
                handleDraftChange("draftID", draftno);
                handleDraftChange("draftFromValue", 3);
                setDraft((prevState) => ({
                  ...prevState,
                  draftID: draftno,
                }));
                NotificationService({
                  title: currentLang?.Success,
                  message: "Draft saved successfully",
                  type: "success",
                });
                const publicUserId = getStoredValue("userID");
                dispatch(
                  archivedActions.PULoginUnreadNotificationCount({
                    publicUserId,
                  })
                );
                setDraftActive(true);
                navigate(".", {
                  replace: true,
                  state: {
                    ...location.state,
                    DraftID: draftno,
                    MessageTo: updatedDraft?.inmateID,
                    MessageSubject: updatedDraft?.MessageSubject || message.subject,
                    MessageBody: updatedDraft?.messageBody || message.messageBody, // Ensure it's always a string
                  },
                });
                break;
              case 2:
                handleDraftChange("draftID", draftno);
                setDraft((prevState) => ({
                  ...prevState,
                  draftID: draftno,
                }));
                setMessage((prevState) => ({
                  ...prevState,
                  draftID: draftno,
                }));
                NotificationService({
                  title: currentLang?.Success,
                  message: "Draft updated successfully",
                  type: "success",
                });

                navigate(".", {
                  replace: true,
                  state: {
                    ...location.state,
                    DraftID: draftno,
                    MessageTo: updatedDraft?.inmateID,
                    MessageSubject: updatedDraft?.MessageSubject || message.subject,
                    MessageBody: updatedDraft?.messageBody || message.messageBody, // Ensure it's always a string
                  },
                });
                setDraftActive(true);


                break;
              case -6:
                setPaymentMsg(
                  "The Permission to send Message to this contact has been restricted. "
                );
                setIsPaymentMsg(true);
                dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
                loadInmateDetails("Message");
                break;
              default:
                break;
            }
          }
        }
      );

      return updatedDraft;
    });
  };

  // Clear Form
  const handleReset = () => {
    //  prevValueRef.current = ""
    prevValueRef.current = { subject: "", message: "" };
    // Event Log - Write Message menu Reset button
    CreateEventLogTextFileForInbox(
      dispatch,
      "Write Message/ Photo menu – Write Message Menu: Reset button clicked.",
      "---",
      "---",
      "Cleared filled Input details"
    );
    if (draftActive === false) {
      dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
      loadInmateDetails("Message");
      setCreditBalance(initialCreditBalance);
      setMessage(initialMessage);
      setDraft(initialDraft);
      setShowCreditsAndMessageCost(false);
      setErrors({});
      setIsDraftModified(false);
      setIsDisabledMsgInmateID(false);
      clearDraft();
      document
        .querySelectorAll(".border-danger")
        .forEach((el) => el.classList.remove("border-danger"));
      resetLocationState();
    } else {
      DraftLoadReset();
      setErrors({});
      document
        .querySelectorAll(".border-danger")
        .forEach((el) => el.classList.remove("border-danger"));
      setIsHasMsgEmojiPermission(false);
      if (isFromDraft === true && location.state?.MessageTo !== 0) {
        setIsDisabledMsgInmateID(true);
      }
      else {
        setIsDisabledMsgInmateID(false);
      }

    }
  };

  const handleForceReset = () => {
    if (location.state?.MessageBody) {
      location.state.MessageBody = null;
    }
    resetLocationState();
    clearDraft();
    setCreditBalance(initialCreditBalance);
    setMessage(initialMessage);
    setDraft(initialDraft);
    loadInmateDetails("Message");
    setDraftActive(false);
    setShowCreditsAndMessageCost(false);
    setErrors({});
    setIsDraftModified(false);
    setIsDisabledMsgInmateID(false);
    document
      .querySelectorAll(".border-danger")
      .forEach((el) => el.classList.remove("border-danger"));
    dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
  };

  const resetLocationState = () => {
    if (location.state) {
      // Replace the state with null or an empty object
      navigate(".", { replace: true, state: null }); // This removes the state from history
    }
  };

  // Clear Send Photo Tab
  const handlePhotoReset = () => {
    // 
    prevValueRef.current = { subject: "", message: "" };
    CreateEventLogTextFileForInbox(
      dispatch,
      "Write Message/ Photo menu – Photo Menu: Reset button clicked.",
      "---",
      "---",
      "Cleared filled Input details",
    );

    if (location.state?.PhotoInmateID) {
      location.state.PhotoInmateID = null;
    }
    dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
    loadInmateDetails("Photo");
    setSelectedImage(null);
    setRotation(0);
    setCreditBalance(initialCreditBalance);
    setPhoto(initialPhoto);
    setShowCreditsAndMessageCost(false);
    setSelectedImage(null);
    setIsDisabledInmateID(false);
    const imageInput = document.getElementById("ImageUpload");
    if (imageInput) {
      imageInput.value = ""; // Reset the file input
    }
    setErrors({});
    document
      .querySelectorAll(".border-danger")
      .forEach((el) => el.classList.remove("border-danger"));
  };

  const handleDraftSave = () => {
    // Auto Draft save
    const savedDraft = getStoredValue("draft");
    if (savedDraft != null) {
      setIsSaveDraftModified(true);
    }
  }

  // Clear Send Photo Tab
  const handleEcardReset = () => {
    setIsFullScreen(false);
    setEcard(initialEcard);
    // setEcardImages([]);
    // setSelectedEcard(null);
    setIsDisabledInmateID(false);
    setShowCreditsAndMessageCost(false);
    // {creditBalance?.IsEmojiEnabled === true && (
    setCreditBalance((prevState) => ({
      ...prevState, // Spread previous state
      IsEmojiEnabled: false, // Update specific property
    }));

    setErrors({});
    document
      .querySelectorAll(".border-danger")
      .forEach((el) => el.classList.remove("border-danger"));
  };

  // Function user for Redirect purchase credit page
  const handleRedirectPurchaseCredit = () => {
    setShowCODPopup(false);
    handleClickRedirect();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return; // Exit if no file is selected

    const acceptedFormats = ["image/jpeg", "image/png", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes

    const imageInput = document.getElementById("ImageUpload");

    if (!acceptedFormats.includes(file.type)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        file: "Please upload an image in .jpg, .jpeg, or .png format.",
      }));
      if (imageInput) imageInput.value = ""; // Reset file input
      return;
    }

    if (file.size > maxSize) {
      NotificationService({
        title: currentLang?.Warning,
        message: "Invalid file size. File size must not exceed 5MB.",
        type: "warning",
      });

      // Reset input field and state
      setPhoto(initialPhoto);
      setCreditBalance(initialCreditBalance);
      setErrors({});
      handlePhotoReset();
      if (imageInput) imageInput.value = ""; // Clear the file input

      return; // Exit function, do not proceed
    }

    // Clear errors if validation passes
    setErrors((prevErrors) => ({
      ...prevErrors,
      file: "",
    }));
    document
      .querySelectorAll(".border-danger")
      .forEach((el) => el.classList.remove("border-danger"));


    // Read the file as Data URL (Base64)
    const reader = new FileReader();
    reader.onloadend = async () => {
      let result = reader.result;
      if (result) {
        let base64 = result.split(",");
        setSelectedImage(result); // Display image
        // Load EXIF data directly from the arrayBuffer (the file content)
        EXIF.getData(file, function () {
          const exifData = EXIF.getAllTags(this);
          const fileSizeInKB = (file.size / 1024).toFixed(2); // File size in KB

          // EXIF strings often carry trailing \0 or '&' / '<' (e.g. "AT&T"), which break the XML column in DB
          const escapeExif = (value) =>
            String(value ?? "")
              .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, "")
              .trim()
              .replace(/&/g, "&amp;")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
              .replace(/"/g, "&quot;")
              .replace(/'/g, "&#39;");

          const orientationText = (() => {
            switch (exifData.Orientation) {
              case 1: return "Horizontal (normal)";
              case 2: return "Flipped horizontally";
              case 3: return "Upside down (Vertical)";
              case 4: return "Flipped vertically";
              case 5: return "Rotated 90° counterclockwise and flipped horizontally";
              case 6: return "Rotated 90° counterclockwise";
              case 7: return "Rotated 90° clockwise and flipped horizontally";
              case 8: return "Rotated 90° clockwise";
              default: return "Horizontal (normal)";
            }
          })();

          let DateTimeOriginal = "-";
          if (exifData.DateTimeOriginal) {
            const dateParts = exifData.DateTimeOriginal.split(" "); // Split date and time
            const date = dateParts[0].split(":"); // Split the date (YYYY:MM:DD)
            const time = dateParts[1]; // Time is already HH:MM:SS
            DateTimeOriginal = `${date[1]}-${date[2]}-${date[0]} ${time}`; // MM-DD-YYYY HH:MM:SS
          }

          // Build the cleanExifInfo table with dynamic values
          const cleanExifInfo = `
        <table class="table table-bordered">  
          <tbody style="font-size: 16px">
            <!-- File Section -->
            <tr>
              <td colspan="2" style="background-color: #e86a6a; font-weight: bold; text-align: left; padding: 8px; color: #fff;">File</td>
            </tr>
            <tr>
              <td>Filename</td>
              <td>${file.name.replace(/[^a-zA-Z0-9._-]/g, "_") || '-'}</td>
            </tr>
            <tr>
              <td>File Size</td>
              <td>${fileSizeInKB || '-'} KB</td>
            </tr>
            ${orientationText ? `
            <tr>
              <td>Orientation</td>
              <td class="Orientation">${orientationText || '-'}</td>
            </tr>` : ''}
            ${exifData?.PixelXDimension ? `
            <tr>
              <td>Image Width</td>
              <td>${escapeExif(exifData.PixelXDimension) || '-'}</td>
            </tr>` : ''}
            ${exifData?.PixelYDimension ? `
            <tr>
              <td>Image Height</td>
              <td>${escapeExif(exifData.PixelYDimension) || '-'}</td>
            </tr>` : ''}
            ${exifData?.Make ? `
            <tr>
              <td>Make</td>
              <td>${escapeExif(exifData.Make) || '-'}</td>
            </tr>` : ''}
            ${exifData?.Model ? `
            <tr>
              <td>Model</td>
              <td>${escapeExif(exifData.Model) || '-'}</td>
            </tr>` : ''}
            <!-- Additional Details -->
            ${DateTimeOriginal && DateTimeOriginal !== '-' ? `
            <tr>
              <td>Date Taken</td>
              <td>${escapeExif(DateTimeOriginal) || '-'}</td>
            </tr>` : ''}
            ${exifData?.ExposureTime ? `
            <tr>
              <td>Exposure Time</td>
              <td>${escapeExif(exifData.ExposureTime) || '-'}</td>
            </tr>` : ''}
            ${exifData?.FNumber ? `
            <tr>
              <td>Aperture</td>
              <td>${escapeExif(exifData.FNumber) || '-'}</td>
            </tr>` : ''}
            ${exifData?.ISOSpeedRatings ? `
            <tr>
              <td>ISO Speed</td>
              <td>${escapeExif(exifData.ISOSpeedRatings) || '-'}</td>
            </tr>` : ''}
            ${exifData?.FocalLength ? `
            <tr>
              <td>Focal Length</td>
              <td>${escapeExif(exifData.FocalLength) || '-'}</td>
            </tr>` : ''}
            <!-- Composite Section -->
            ${(exifData?.PixelXDimension && exifData?.PixelYDimension) ? `
            <tr>
              <td colspan="2" style="background-color: #e86a6a; font-weight: bold; text-align: left; padding: 8px; color: #fff;">Composite</td>
            </tr>
            <tr>
              <td>Image Size</td>
              <td>${escapeExif(exifData.PixelXDimension)}x${escapeExif(exifData.PixelYDimension)}</td>
            </tr>
            <tr>
              <td>Megapixels</td>
              <td>${((exifData.PixelXDimension * exifData.PixelYDimension) / 1000000).toFixed(2)}</td>
            </tr>` : ''}
          </tbody>
        </table>
        `.trim();
          // Update the state with dynamic Exif information     
          setPhoto((prevState) => ({
            ...prevState,
            file: base64[1], // Store Base64 string
            filename: file.name.replace(/[^a-zA-Z0-9._-]/g, "_"), // Store filename
            fileType: file?.type,
            photoCost: creditBalance?.FacilityPhotoCost.toFixed(2),
            photoExifInfo: cleanExifInfo,
          }));
        });
        // const photoExifInfo = await extractExifInfo(result);

        // setPhoto((prevState) => ({
        //   ...prevState,
        //   file: base64[1], // Store Base64 string
        //   filename: file.name, // Store filename
        //   photoCost: creditBalance?.FacilityPhotoCost.toFixed(2),
        //   photoExifInfo 
        // }));
        setRotation(0);
      }
    };
    reader.readAsDataURL(file);
  };

  const rotateImage = (direction) => {
    showLoader();
    if (!photo.file) {
      hideLoader();
      return;
    }

    // EventLog - For track image rotation
    CreateEventLogTextFileForInbox(
      dispatch,
      `Write Message/ Photo menu - Send Photo Menu - Rotate button clicked (${direction === "left" ? 90 : direction === "right" ? 270 : direction === "flip" ? 180 : 0})`,
      "---",
      "---",
      `Photo Rotate to (${direction === "left" ? 90 : direction === "right" ? 270 : direction === "flip" ? 180 : 0}) degree`

    );


    const base64Prefix = `data:${photo.fileType};base64,`;
    const imageSrc = photo.file.startsWith(base64Prefix)
      ? photo.file
      : `${base64Prefix}${photo.file.trim()}`;

    // Adjust the EXIF Orientation based on the rotation direction
    const updateExifOrientation = (orientation, rotationDirection) => {
      const orientationMap = {
        1: { right: 3, left: 6, flip: 3 },
        6: { right: 8, left: 3, flip: 8 },
        3: { right: 6, left: 8, flip: 1 },
        8: { right: 1, left: 6, flip: 6 },
      };
      return orientationMap[orientation]?.[rotationDirection] || 1;
    };

    const img = new Image();
    img.src = imageSrc;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      let width = img.width;
      let height = img.height;

      // Set canvas dimensions based on rotation direction
      if (direction === "right" || direction === "left") {
        canvas.width = height;
        canvas.height = width;
      } else {
        canvas.width = width;
        canvas.height = height;
      }

      ctx.fillStyle = "white"; // Fill background (if needed)
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.save();

      let newRotationState = "0°"; // Default rotation state

      // Apply the rotation based on the direction and update the rotation state
      if (direction === "right") {
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((90 * Math.PI) / 180); // 90° clockwise
        setRotation((prev) => (prev + 90) % 360); // Update rotation state
        newRotationState = ((rotation + 90) % 360);
      } else if (direction === "left") {
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate((-90 * Math.PI) / 180); // 90° counter-clockwise
        setRotation((prev) => (prev - 90 + 360) % 360); // Update rotation state
        newRotationState = ((rotation - 90 + 360) % 360);
      } else if (direction === "flip") {
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(Math.PI); // 180° flip
        setRotation((prev) => (prev + 180) % 360); // Update rotation state
        newRotationState = ((rotation + 180) % 360);
      }
      ctx.drawImage(img, -width / 2, -height / 2, width, height);
      ctx.restore();
      const orientationText = (() => {
        switch (newRotationState) {
          case 0: return "Horizontal (normal)";
          case 90: return "Rotated 90° clockwise";
          case 180: return "Flipped Horizontal";
          case 270: return "Rotated 90° counterclockwise";
          default: return "Horizontal (normal)";
        }
      })();

      // Handle EXIF for JPG/JPEG
      let rotatedBase64;
      const updatedExifInfo = photo?.photoExifInfo.replace(
        /(<td class="Orientation">)[^<]*(<\/td>)/,
        `$1${orientationText}$2`
      );
      if (photo.fileType === "image/png") {
        // For PNG, just use canvas to get the new base64
        rotatedBase64 = canvas.toDataURL("image/png");
      } else {
        // For JPG/JPEG, handle EXIF and apply it
        const exifData = piexif.load(imageSrc);

        const updatedOrientation = updateExifOrientation(
          exifData["0th"][piexif.ImageIFD.Orientation] || 1,
          0
        );
        exifData["0th"][piexif.ImageIFD.Orientation] = updatedOrientation;

        // Insert EXIF data into the new rotated image
        rotatedBase64 = canvas.toDataURL("image/jpeg");
        const newBase64WithExif = piexif.insert(piexif.dump(exifData), rotatedBase64);

        // Update the photo state with EXIF and rotated image data
        setPhoto((prevState) => ({
          ...prevState,
          file: newBase64WithExif.split(",")[1], // Strip the prefix for consistency
          filename: prevState.filename,
          photoCost: prevState.photoCost,
          photoExifInfo: updatedExifInfo,
        }));
        hideLoader();
        return;
      }

      // Update the photo state with the rotated image
      setPhoto((prevState) => ({
        ...prevState,
        file: rotatedBase64.split(",")[1], // Strip the prefix for consistency
        filename: prevState.filename,
        photoCost: prevState.photoCost,
        photoExifInfo: updatedExifInfo, // No need to update EXIF for PNG
      }));
      hideLoader();
    };

    img.onerror = (error) => {
      console.error("Failed to load image. Check the Base64 data.", error);
      hideLoader();
    };

  };

  // Photo Send
  const handlePhotoSend = (e) => {
    setSendPhotoConfirmation(false);
    setShouldDisplayHTMLMessage(false);
    // } else {
    showLoader();
    const startTime = performance.now();
    dispatch(
      writeMessageActions.InsertUpdatePhotoCommunicationSent(photo)
    ).then((response) => {

      const endTime = performance.now();
      const executionTimeInSeconds = (endTime - startTime) / 1000;

      const infoMessage = `Sent New photo to Inmate (Inmate ID - ${photo?.inmatesId})`;
      const redirectURL = '---';
      const Response = `Execution Time -  ${executionTimeInSeconds.toFixed(2)} seconds, Sent Message Subject: ${message?.subject}, Sent Message Body: ${message?.messageBody}  ` + JSON.stringify(selectedInmate);
      let Status = '---';


      if (response?.meta?.requestStatus === "fulfilled") {
        hideLoader();
        let status = response?.payload;
        switch (status) {
          case 1:
            NotificationService({
              title: currentLang?.Success,
              message: currentLang?.InboxPopContent?.Photo_Sent_Success,
              type: "success",
            });
            Status = "Photo sent successfully";
            handlePhotoReset();
            break;
          case -1:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.Photo_Sent_Failed,
              type: "warning",
            });
            Status = "Photo sent Failed";
            break;
          case -2:
            // NotificationService({
            //   title: currentLang?.Warning,
            //   message: "COD Photo",
            //   type: "warning",
            // });
            setisCreditamountModal(true);
            setMsgCreditamount(
              activeTab === "ecard"
                ? currentLang?.ECardPopContent?.Low_balance_Card
                : currentLang?.ECardPopContent?.Low_balance_Photo
            );
            Status = "You have insufficient balance to send the photo. Please buy credits to send the photo.";
            handlePhotoReset();
            break;
          case -3:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.InboxPopContent?.Repeated_Photo,
              type: "warning",
            });
            Status = "Repeated Photo.";
            handlePhotoReset();
            break;
          case -4:
            setPaymentMsg(currentLang?.InboxPopContent?.PU_InActive);
            setIsPaymentMsg(true);
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Photo");
            Status = "Public User Inmate connection is Inactive.";
            break;
          // case -5:
          //   setPaymentMsg("Public User Deactivated/Inactivated");
          //   setIsPaymentMsg(true);
          //   dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
          //   loadInmateDetails("Photo");
          //   Status ="Public User Deactivated/Inactivated.";
          //   break;
          case -6:
            setPaymentMsg(currentLang?.ECardPopContent?.Restricted_SentPhotos);
            setIsPaymentMsg(true);
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Photo");
            Status = "The permission to send Photos to this contact has been restricted.";
            handlePhotoReset();
            break;
          case -5:
          case -7:
            setPaymentMsg(currentLang?.ECardPopContent?.connection_Blocked);
            setIsPaymentMsg(true);
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Photo");
            Status = "Connection is blocked/rejected.";
            handlePhotoReset();
            break;
          case -8:
            setPaymentMsg(currentLang?.ECardPopContent?.No_longer_connected);
            setIsPaymentMsg(true);
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Photo");
            Status = "You are no longer connected with this user.";
            break;
          default:
            break;
        }
      }

      CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status)
    });
    setActiveTab("sendPhoto");
  };

  const handleClickOutside = (event) => {
    if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
      setIsSubjectIconPickerOpen(false); // Close picker only if click is outside
      setIsDescIconPickerOpen(false);
    }
  };

  useEffect(() => {
    if (isSubjectIconPickerOpen || isDescIconPickerOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSubjectIconPickerOpen, isDescIconPickerOpen]);

  // --------------------- Ecard Send ----------------------
  const handleEcardSend = (e) => {
    setSendEcardConfirmation(false);
    setShouldDisplayHTMLMessage(false);
    // } else {
    showLoader();
    dispatch(
      writeMessageActions.InsertUpdateEcardCommunicationSent(ecard)
    ).then((response) => {
      if (response?.meta?.requestStatus === "fulfilled") {
        hideLoader();
        let status = response?.payload;
        switch (status) {
          case 1:
            NotificationService({
              title: currentLang?.Success,
              message: currentLang?.ECardPopContent?.ECard_sent_Success,
              type: "success",
            });
            handleEcardReset();
            break;
          case -1:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.ECardPopContent?.ECard_sent_Failed,
              type: "warning",
            });
            break;
          case -2:
            // NotificationService({
            //   title: currentLang?.Warning,
            //   message: "COD Photo",
            //   type: "warning",
            // });
            setisCreditamountModal(true);
            setMsgCreditamount(
              activeTab === "ecard"
                ? currentLang?.ECardPopContent?.Low_balance_Card
                : currentLang?.ECardPopContent?.Low_balance_Photo
            );
            handleEcardReset();
            break;
          case -3:
            NotificationService({
              title: currentLang?.Warning,
              message: currentLang?.ECardPopContent?.Repeated_Ecard,
              type: "warning",
            });
            // handleEcardReset();
            break;
          case -4:
            // setPaymentMsg("Public User Inmate connection is Inactiv");
            setPaymentMsg(currentLang?.ECardPopContent?.connection_Blocked);
            setIsPaymentMsg(true);
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Photo"); // Need to change Ecard
            break;
          case -5:
            setPaymentMsg(currentLang?.ECardPopContent?.PU_Deactivated_Inactivated);
            setIsPaymentMsg(true);
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Photo"); // Need to change Ecard
            break;
          case -6:
            setPaymentMsg(currentLang?.ECardPopContent?.No_Permission);
            setIsPaymentMsg(true);
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Photo"); // Need to change Ecard
            handleEcardReset();
            break;
          case -7:
            setPaymentMsg(currentLang?.ECardPopContent?.connection_Blocked);
            setIsPaymentMsg(true);
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Photo"); // Need to change Ecard
            break;
          case -8:
            setPaymentMsg(currentLang?.ECardPopContent?.No_longer_connected);
            setIsPaymentMsg(true);
            dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            loadInmateDetails("Photo"); // Need to change Ecard
            break;
          default:
            break;
        }
      }
    });
    setActiveTab("ecard");
  };

  const handleClickRedirect = () => {
    showLoader();
    dispatch(
      sendPhotosActions.CheckingMsgPhotoStatus({
        addFormData: { UserID: UserID, InmateID: InmateID },
      })
    ).then((x) => {
      const apiResponse = x?.payload;
      if (apiResponse) {
        const { Result, Notes } = apiResponse;
        switch (Result) {
          case -7:
            setPaymentMsg(currentLang?.ArchivedPagePopContent?.Connection_Blocked);
            setIsPaymentMsg(true);
            if (activeTab == "sendPhoto") {
              handlePhotoReset();
            } else if (activeTab == "message") {
              handleForceReset();
            }
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
            break;
          case -8:
            setPaymentMsg(currentLang?.ArchivedPagePopContent?.No_longer_connected);
            setIsPaymentMsg(true);
            if (activeTab == "sendPhoto") {
              handlePhotoReset();
            } else if (activeTab == "message") {
              handleForceReset();
            }
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
            break;
          case -6:
            setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Contact);
            setIsPaymentMsg(true);
            if (activeTab == "sendPhoto") {
              handlePhotoReset();
            } else if (activeTab == "message") {
              handleForceReset();
            }
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
            break;
          case -4:
            setPaymentMsg(currentLang?.ArchivedPagePopContent?.Disabled_Facility);
            setIsPaymentMsg(true);
            if (activeTab == "sendPhoto") {
              handlePhotoReset();
            } else if (activeTab == "message") {
              handleForceReset();
            } else {
              handleEcardReset();
            }
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
            break;
          case -3:
            setPaymentMsg(Notes);
            setIsPaymentMsg(true);
            if (activeTab == "sendPhoto") {
              handlePhotoReset();
            } else if (activeTab == "message") {
              handleForceReset();
            }
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
            break;
          default:
            if (Result === 0) {
              // If success response (result = 0), redirect
              setStoredValue("InmateID", InmateID);
              navigate("/public/PurchaseCredits", {
                state: { previousPath: location.pathname },
              });
              storeCurrentRoute("/public/PurchaseCredits");
              dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
            }
            break;
        }
        setisCreditamountModal(false);
      }
      hideLoader();
    })

    // EventLog - For track COD Message/ Photo Send
    CreateEventLogTextFileForInbox(
      dispatch,
      `Write Message / Photo menu - COD ${activeTab} sent, navigating to Purchase History page`,
      "---",
      "---",
      `User submitted COD ${activeTab}. Redirected to Purchase History.`
    );



  };

  const handleClickEmojiPermission = () => {
    setPhoto((prevState) => ({
      ...prevState,
      subject: "",
    }));
    setIsHasEmojiPermission(false);
  };

  const handleCancelEmojiPermission = () => {
    setIsHasEmojiPermission(false);
  };

  const handleClickMsgEmojiPermission = () => {
    setMessage((prevState) => ({
      ...prevState,
      subject: "",
      messageBody: "",
    }));
    setIsHasMsgEmojiPermission(false);
  };

  useEffect(() => {
    DraftLoadReset();
  }, [LoadPublicMyContactsDisplay, PublicMyContactsDisplayNew]);

  const DraftLoadReset = () => {
    if (location.state?.MessageBody && activeTab === "message") {
      setMessage((prevState) => ({
        ...prevState,
        subject: "",
        messageBody: "",
      }));
      setDraftActive(true);
      setDraft((prevState) => ({
        ...prevState,
        draftID: location?.state?.DraftID,
      }));
      prevValueRef.current["subject"] = location.state?.MessageSubject;
      prevValueRef.current["message"] = location.state?.MessageBody;
      handleDraftChange("draftID", location.state?.DraftID);
      handleDraftChange("subject", location.state?.MessageSubject);
      handleDraftChange("inmateID", location.state?.MessageTo);
      handleDraftChange("messageBody", location.state?.MessageBody);
      setMessage((prevState) => ({
        ...prevState,
        draftID: location?.state?.DraftID,
      }));

      setMessage((prevState) => ({
        ...prevState,
        subject: location.state.MessageSubject || "",
        messageBody: location.state.MessageBody || "",
      }));
      // if (location.state.MessageTo) {
      //   if (Array.isArray(LoadPublicMyContactsDisplay)) {
      //     const filteredContacts = LoadPublicMyContactsDisplay.filter(
      //       (item) => item.value === location.state.MessageTo
      //     );
      //     if (filteredContacts.length === 1) {
      //       const data = filteredContacts[0];
      //       handleSelectChange(data, "inmatesId");
      //       setIsDisabledMsgInmateID(location.state?.MessageTo ? true : false);
      //     }
      //   }
      // }
      if (!location.state.MessageTo) {
        setMessage((prevState) => ({
          ...prevState,
          inmatesId: null, // Clear the inmate ID
        }));
        setCreditBalance({
          CreditBalance: 0,
          FacilityEmojiCost: 0,
          FacilityMessageCost: 0,
          FacilityPhotoCost: 0,
          FacilityEcardCost: 0,
          IsEmojiEnabled: false,
        });
        setShowCreditsAndMessageCost(false);
      } else {
        const InmateLoadedDetails =
          LoadPublicMyContactsDisplay !== null &&
            LoadPublicMyContactsDisplay?.length !== undefined
            ? LoadPublicMyContactsDisplay !== null &&
              LoadPublicMyContactsDisplay?.length !== undefined &&
              LoadPublicMyContactsDisplay.length === 0
              ? PublicMyContactsDisplayNew
              : LoadPublicMyContactsDisplay
            : PublicMyContactsDisplayNew;
        if (Array.isArray(InmateLoadedDetails)) {
          const filteredContacts = InmateLoadedDetails.filter(
            (item) => item.value === location.state.MessageTo
          );
          if (filteredContacts.length === 1) {
            // Emoji check: if emojis are present and IsEmojiEnabled is false, show the popup
            const emojiRegex =
              /[\uD800-\uDBFF][\uDC00-\uDFFF]|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu;
            const messageBody = location.state?.MessageBody || "";
            const messageSubject = location.state?.MessageSubject || "";
            const combinedMessage = messageBody + messageSubject;

            if (
              emojiRegex.test(combinedMessage) &&
              !filteredContacts[0]?.IsEmojiEnabled
            ) {
              setIsHasMsgEmojiPermission(true);
            } else {
              setIsHasMsgEmojiPermission(false);
            }
            const data = filteredContacts[0];
            handleSelectChange(data, "inmatesId");
            setIsDisabledMsgInmateID(location.state?.MessageTo && location.state?.MessageTo !== 0 ? true : false);
          } else if (filteredContacts.length === 0) {
            setIsDisabledMsgInmateID(false);
            setIsHasMsgEmojiPermission(false);
            handleSelectChange(0, "inmatesId");
          }
        }
      }
    }
  };

  // load selected photo
  useEffect(() => {
    if (PhotoInmateID) {
      loadInmateDetails("Photo");
      setActiveTab("sendPhoto");
    } else if (EcardInmateID) {
      loadInmateDetails("Photo");
      setActiveTab("ecard");
    }
  }, [PhotoInmateID, EcardInmateID]);

  // load selected photo
  useEffect(() => {
    if (PhotoInmateID || EcardInmateID) {
      let InmateID = PhotoInmateID ? PhotoInmateID : EcardInmateID;
      if (Array.isArray(LoadPublicMyContactsDisplay)) {
        const filteredContacts = LoadPublicMyContactsDisplay.filter(
          (item) => item.value === InmateID
        );
        if (filteredContacts.length === 1) {
          const data = filteredContacts[0];
          handleSelectChange(data, "inmatesId");
          setIsDisabledInmateID(true);
        }
      }
      //setActiveTab("sendPhoto");
    }
  }, [PhotoInmateID, EcardInmateID, LoadPublicMyContactsDisplay]);

  // Inbox - New Message Redirect functionality
  useEffect(() => {
    if (NewMessageID) {
      if (Array.isArray(LoadPublicMyContactsDisplay)) {
        const filteredContacts = LoadPublicMyContactsDisplay.filter(
          (item) => item.value === NewMessageID
        );
        if (filteredContacts.length === 1) {
          const data = filteredContacts[0];
          handleSelectChange(data, "inmatesId");
          setIsDisabledMsgInmateID(true);
        }
      }
      //  setActiveTab("sendPhoto");
    }
  }, [NewMessageID, LoadPublicMyContactsDisplay]);

  const handleSendEmojiRejectPopupClose = () => {
    if (activeTab === "sendPhoto") {
      setSendEmojiRejectPopup(false);
      handlePhotoReset();
    } else {
      setSendEmojiRejectPopup(false);
    }
  };

  function cleanFileName(fileName) {
    return fileName.replace(/\.[^.]+(?=\.(png|jpg|jpeg|gif|webp|bmp|svg)$)/i, '');
  }

  // Function used for Convert image URL to base64 
  const convertToBase64 = (image) => {
    const img = new Image();
    img.src = image;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const base64String = canvas.toDataURL();
      let baseData = base64String?.split(";base64,");
      let imageName = image?.split("media/");
      const cleanedFileName = cleanFileName(imageName[1]);

      // setBase64Data(base64String);
      setEcard((prevState) => ({
        ...prevState,
        filename: cleanedFileName,
        file: baseData[1],
      }));
    }
  };

  // Function used for set Random Image in ecard gallary
  useEffect(() => {
    if (ecardImages?.length > 1) {
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * ecardImages.length);
      } while (ecardImages[newIndex] === selectedEcard); // Ensure it's different

      setSelectedEcard(ecardImages[newIndex]);
      convertToBase64(ecardImages[newIndex]);
    } else if (ecardImages?.length === 1) {
      setSelectedEcard(ecardImages[0]);
      convertToBase64(ecardImages[0]);
    }
  }, [activeTab]);
  // Runs when selectedInmate changes

  return (
    <>
      {" "}
      {/* <Marquee
        gradient={false}
        speed={30}
        pauseOnHover={true}
        style={{ color: "#cf5c5c", backgroundColor: "#fee", fontSize: '15px', marginBottom: "1rem" }}
      >
        The E-Card feature is now available for your below inmate facilities! -
        {EcardFacilityList?.join(", ")}
      </Marquee> */}

      <AlertPopup
        show={showAlert}
        onClose={() => setShowAlert(false)}
        title="E-Cards Are Now Live!"
        facilities={EcardFacilityList || []}
        confirmButtonText="OK"
        useConfirmCancel={false}
        onConfirm={() => { }}
      />
      <ReactNotifications />
      <div className="height-100" data-scrollbar="true" data-height="100%">
        {/* ---------- Write Message Component Header Section -------- */}
        <div className="">
          <div className="header-title">
            <h5>
              {/* <i className="fa fa-file-text me-3 fs-14"></i> */}
              {currentLang?.WriteMessage}
            </h5>
          </div>
        </div>

        <div
          className="card p-4 border-radius-all shadow-sm mb-5 h-100"
          data-scrollbar="true"
        >
          <div className="card-header pt-0 padding-r-l-0 bg-white">
            <ul className="nav nav-tabs card-header-tabs flex-wrap">
              {/*----------- Message Tab ---------------------*/}
              <li className="nav-item">
                <button
                  className={`nav-link d-flex align-items-center  py-2 border-0 mobile-pd-06  ${activeTab === "message"
                    ? "active text-success border-bottom border-success border-2"
                    : ""
                    }`}
                  onClick={() => {
                    setActiveTab("message");
                    dispatch(writeMessageActions?.clearSelectedCategories())
                    handleReset();
                    handlePhotoReset();
                    setIsSubjectIconPickerOpen(false);
                    const infoMessage = `message - Tab Click in Write Message Page`;
                    const redirectURL = 'public/WriteMessage';
                    const Response = '---';
                    const Status = '---';
                    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status)
                  }}
                >
                  {/* <i className="bi bi-chat-left-dots-fill mt-1 me-2 font-size-15"></i> */}
                  <i className="fa fa-envelope  me-2 font-size-17"></i>
                  {currentLang?.Message || "Message"}
                </button>
              </li>
              {/*------------Send Photo Tab ------------------- */}
              <li className="nav-item">
                <button
                  className={`nav-link d-flex align-items-center py-2 border-0 mobile-pd-06 ${activeTab === "sendPhoto"
                    ? "active text-success border-bottom border-success border-2"
                    : ""
                    }`}
                  onClick={() => {
                    setActiveTab("sendPhoto");
                    handleDraftSave();
                    handlePhotoReset();
                    dispatch(writeMessageActions?.clearSelectedCategories())
                    setIsSubjectIconPickerOpen(false);
                    const infoMessage = `sendPhoto - Tab Click in Write Message Page`;
                    const redirectURL = 'public/WriteMessage';
                    const Response = '---';
                    const Status = '---';
                    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status)
                  }}
                >
                  <i className="fa fa-paper-plane me-2 mt-1 font-size-15"></i>
                  {currentLang?.SentPhotos || "Send Photo"}
                </button>
              </li>
              {/*---------- E-Card Tab (Enabled) -------------- */}
              <li className="nav-item" disabled>
                <button
                  className={`nav-link d-flex align-items-center py-2 border-0 mobile-pd-06 ${activeTab === "ecard"
                    ? "active text-success border-bottom border-success border-2"
                    : ""
                    }`}
                  onClick={() => {
                    setActiveTab("ecard");
                    handleDraftSave();
                    handleEcardReset();
                    setIsFullScreen(false);
                    setIsSubjectIconPickerOpen(false);
                    const infoMessage = `E-Card - Tab Click in Write Message page`;
                    const redirectURL = 'public/WriteMessage';
                    const Response = '---';
                    const Status = '---';
                    CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status)
                  }}
                >
                  {/* <i className="bi bi-star-fill me-2 mt-1 font-size-15"></i> */}
                  <i className="fa-solid fa-cake-candles me-2 mt-1 font-size-15"></i>
                  {currentLang?.Ecard || "Ecard"}
                </button>
              </li>
            </ul>
          </div>

          <div className="bg-white mt-3">
            <div className="tab-content  pt-0">
              {/* ------------------------------- Send Message Tab - Content section------------------------------------*/}
              {activeTab === "message" && ( // Checks if the active tab is "message"
                <div className="row">
                  <div className="col-12 col-md-6 mb-2">
                    <SelectInput
                      options={
                        LoadPublicMyContactsDisplay !== null &&
                          LoadPublicMyContactsDisplay?.length !== undefined
                          ? LoadPublicMyContactsDisplay !== null &&
                            LoadPublicMyContactsDisplay?.length !== undefined &&
                            LoadPublicMyContactsDisplay.length === 0
                            ? PublicMyContactsDisplayNew
                            : LoadPublicMyContactsDisplay
                          : PublicMyContactsDisplayNew
                      }
                      value={message?.inmatesId}
                      onChange={(selectedOption) =>
                        handleSelectChange(selectedOption, "inmatesId", false)
                      }
                      name="inmatesId"
                      labelKey="label"
                      valueKey="value"
                      isMulti={false}
                      closeMenuOnSelect={true}
                      isDisabled={isDisabledMsgInmateID}
                      isClearable={true}
                      placeholder={currentLang?.WriteMessagePage?.Select_Inmate}
                      label={currentLang?.WriteMessagePage?.Inmate_Name}
                      required={true}
                      handleBlur={null}
                      errorMessage={errors?.inmatesId}
                    />
                    {showCreditsAndMessageCost && (
                      <div className="d-flex flex-column flex-md-row align-items-start fs-5 mb-2">
                        {showCreditsAndMessageCost &&
                          message?.inmatesId !== 0 && (
                            <>
                              <p className="me-3 fs-14">
                                {currentLang?.Avaliable_Credits}{" "}
                                <strong
                                  className={`ms-0 ${creditBalance?.CreditBalance === 0 ||
                                    creditBalance?.FacilityMessageCost >
                                    creditBalance?.CreditBalance
                                    ? "text-danger"
                                    : "txt-success"
                                    }`}
                                >
                                  ${creditBalance?.CreditBalance?.toFixed(2)}
                                </strong>
                              </p>
                              <p className="me-3 fs-14">
                                {currentLang?.Message_Cost}{" "}
                                <strong className="ms-0 txt-success">
                                  $
                                  {creditBalance?.FacilityMessageCost.toFixed(
                                    2
                                  )}
                                </strong>
                              </p>
                            </>
                          )}
                        {creditBalance?.IsEmojiEnabled === true && (
                          <>
                            <p className="me-3 fs-14">
                              {currentLang?.Emoji_Cost}{" "}
                              <strong className="ms-0 txt-success">
                                ${creditBalance?.FacilityEmojiCost.toFixed(2)}
                              </strong>
                              <i
                                class="fa fa-info-circle"
                                title={currentLang?.InboxPopContent?.Same_Emoji}
                                style={{ cursor: "pointer" }}
                              ></i>
                            </p>
                          </>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="col-12 col-md-6 position-relative mb-2">
                    <label className="form-label w-100 inmate-label">
                      {currentLang?.WriteMessagePage?.Subject} <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <input
                        type="text"
                        ref={subjectInputRef}
                        // disabled={disableInput}
                        // onKeyDown={handleKeyDown}
                        inputMode="text"
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck={false}
                        onKeyDown={(e) => {
                          restrictCharacters(e); // Apply character restriction
                          handleKeyDown(e);
                        }}
                        onKeyUp={handleKeyUp}
                        className="form-control mb-5px fs-5 fw-normal pe-5" // Adds padding to the right for the icon
                        value={message?.subject}
                        // onChange={handleChange}
                        onChange={(e) => handleChange(e, true)}
                        name="subject"
                        onClick={handleInputClick}
                        onCopy={(e) => e.preventDefault()}
                        onCut={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onFocus={handleSubjectFocus}
                        onBlur={handleSubjectBlur}
                        // maxLength={50}
                        placeholder={currentLang?.WriteMessagePage?.Subject}
                      // onKeyDown={(e) => {
                      //   if (e.key === "Enter") {
                      //     e.preventDefault();
                      //     handleMessageSend();
                      //   }
                      // }}
                      //   errorMessage={errors?.subject}
                      />
                      {creditBalance?.IsEmojiEnabled === true && (
                        <span
                          className="position-absolute end-0 top-50 translate-middle-y me-3 fs-5 animated-emoji cursor-pointer"
                          onClick={() => handleIconClick("subject")}
                        >
                          😊
                        </span>
                      )}
                    </div>
                    <div className="text-danger fw-700 fs-6 mb-2 mt-1">
                      {errors && errors["subject"]}
                    </div>
                    {isSubjectIconPickerOpen && isSubjectFocused && (
                      <div
                        className="dropdown-menu show p-2 overflow-auto"
                        ref={emojiPickerRef} tabIndex={-1}
                        onMouseDown={(e) => {
                          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                          if (isIOS) {
                            e.preventDefault(); // Prevent input blur only on iOS
                          }
                        }}
                      >
                        <EmojiPicker
                          onEmojiSelect={(emoji) =>
                            handleEmojiSelect(emoji, "subject")
                          }
                          onClose={() => setIsSubjectIconPickerOpen(false)}
                        />
                      </div>
                    )}
                  </div>

                  <div className="mb-1 position-relative">
                    {" "}
                    {/* Added position-relative to the container */}
                    <label className="form-label fs-5 inmate-label">
                      {currentLang?.WriteMessagePage.Message}<span className="text-danger ps-1">*</span>
                    </label>
                    <div className="input-group">
                      <textarea
                        ref={descInputRef}
                        // onKeyDown={handleKeyDown}
                        onKeyDown={(e) => {
                          restrictCharacters(e); // Apply character restriction
                          handleKeyDown(e);
                        }}
                        onKeyUp={handleKeyUp}
                        value={message?.messageBody}
                        name="messageBody"
                        className="form-control mb-5px fs-5 fw-normal pe-5" // Ensure similar styling to the subject input
                        rows="6"
                        placeholder={currentLang?.WriteMessagePage?.Write_Your_Msg} // Optional placeholder
                        onChange={(e) => handleChange(e, true)}
                        onCopy={(e) => e.preventDefault()}
                        onCut={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onFocus={handleMessageFocus}
                        onBlur={handleMessageBlur}
                        onClick={handleInputClick}
                        // maxLength={maxDescriptionLength}
                        autocomplete="off"
                        errorMessage={errors?.messageBody}
                      ></textarea>
                      {creditBalance?.IsEmojiEnabled === true && (
                        <span
                          className="input-group-text animated-emoji-description"
                          onClick={() => handleIconClick("messageBody")}
                        >
                          😊
                        </span>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-6">
                        <div className="text-danger fw-700 fs-6 mb-20px mt-1">
                          {errors && errors["messageBody"]}
                        </div>
                      </div>
                      {/* Update this div to use the adjusted length */}
                      <div className="col-6">
                        <div className="fs-5 text-end">
                          {getDisplayLength(message.messageBody)}/
                          {maxDescriptionLength} {currentLang?.Characters}
                        </div>
                      </div>
                    </div>
                    {isDescIconPickerOpen && isMessageFocused && (
                      <div
                        className="dropdown-menu show p-2 overflow-auto"
                        ref={emojiPickerRef} tabIndex={-1}
                        // onMouseDown={(e) => e.preventDefault()} // 🔒 Prevent input blur on iOS
                        onMouseDown={(e) => {
                          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                          if (isIOS) {
                            e.preventDefault(); // Prevent input blur only on iOS
                          }
                        }}
                      >
                        <EmojiPicker
                          onEmojiSelect={(emoji) =>
                            handleEmojiSelect(emoji, "messageBody")
                          }
                          onClose={() => setIsDescIconPickerOpen(false)}
                        />
                      </div>
                    )}
                  </div>

                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center ">
                    <div>
                      <button
                        className="btn btn-success font-size-14 mb-2 me-2"
                        onClick={handleMessageSend}
                      >
                        <i className="fa-regular fa-paper-plane me-1"></i>{currentLang?.buttons?.Send}
                      </button>
                      <button
                        className="btn btn-danger font-size-14 mb-2 me-2"
                        onClick={handleSaveasDraft}
                      >
                        <i className="fa-regular fa-floppy-disk me-1"></i>
                        {draft?.draftID === 0
                          ? currentLang?.buttons?.SaveAsDraft
                          : currentLang?.buttons?.UpdateDraft}
                      </button>
                      <button
                        className="btn btn-grey font-size-14 mb-2"
                        onClick={handleReset}
                      >
                        <i className="fa-solid fa-arrow-rotate-left me-1"></i>
                        {currentLang?.buttons?.Reset}
                      </button>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12">
                      <p className="fs-5 no-expectation-text">
                        <strong className="text-danger">*</strong> {currentLang?.Msg_Notice_Content}</p>
                    </div>
                  </div>
                </div>
              )}
              {/*--------------------------------- Send Photo Tab- Content Section -------------------------------------*/}
              {activeTab === "sendPhoto" && ( // Checks if the active tab is "sendPhoto"
                <div>
                  <div className="row">
                    <div className="col-12 col-md-6 mb-2 ">
                      <SelectInput
                        options={LoadPublicMyContactsDisplay}
                        value={photo?.inmatesId}
                        onChange={(selectedOption) =>
                          handleSelectChange(selectedOption, "inmatesId", true)
                        }
                        name="inmatesId"
                        labelKey="label"
                        valueKey="value"
                        isMulti={false}
                        closeMenuOnSelect={true}
                        isDisabled={isDisabledInmateID}
                        isClearable={true}
                        placeholder={currentLang?.WriteMessagePage?.Select_Inmate}
                        label={currentLang?.WriteMessagePage?.Inmate_Name}
                        required={true}
                        handleBlur={null}
                        errorMessage={errors?.inmatesId}
                      />
                      {showCreditsAndMessageCost && (
                        <div className="d-flex flex-column flex-md-row align-items-start">
                          {showCreditsAndMessageCost && (
                            <>
                              <p className="me-3 fs-14">
                                {currentLang?.Avaliable_Credits}{" "}
                                <strong
                                  className={`ms-0 ${creditBalance?.CreditBalance === 0 ||
                                    creditBalance?.FacilityPhotoCost >
                                    creditBalance?.CreditBalance
                                    ? "text-danger"
                                    : "txt-success"
                                    }`}
                                >
                                  ${creditBalance?.CreditBalance?.toFixed(2)}
                                </strong>
                              </p>
                              <p className="me-3 fs-14">
                                {currentLang?.Photo_Cost}{" "}
                                <strong className="ms-0 txt-success">
                                  ${creditBalance?.FacilityPhotoCost.toFixed(2)}
                                </strong>
                              </p>
                            </>
                          )}
                          {creditBalance?.IsEmojiEnabled === true && (
                            <>
                              <p className="me-3 fs-14">
                                {currentLang?.Emoji_Cost}{" "}
                                <strong className="ms-0 txt-success">
                                  ${creditBalance?.FacilityEmojiCost.toFixed(2)}
                                </strong>
                                <i
                                  class="fa fa-info-circle"
                                  title={currentLang?.InboxPopContent?.Same_Emoji}
                                  style={{ cursor: "pointer" }}
                                ></i>
                              </p>
                            </>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="col-12 col-md-6 position-relative">
                      <label className="form-label w-100 fs-5 inmate-label">
                        {currentLang?.WriteMessagePage?.Subject} <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          // onKeyDown={handleKeyDownPhoto}
                          inputMode="text"
                          autoComplete="off"
                          autoCorrect="off"
                          spellCheck={false}
                          onKeyDown={(e) => {
                            restrictCharacters(e); // Apply character restriction
                            handleKeyDownPhoto(e);
                          }}
                          onKeyUp={handleKeyUp}
                          ref={subjectPhotoInputRef}
                          className="form-control mb-5px fs-5 fw-normal pe-5" // Adds padding to the right for the icon
                          value={photo?.subject}
                          onChange={(e) => handleChange(e, false)}
                          name="subject"
                          onClick={handleInputClick}
                          onCopy={(e) => e.preventDefault()}
                          onCut={(e) => e.preventDefault()}
                          onPaste={(e) => e.preventDefault()}
                          onFocus={handleSubjectFocus}
                          onBlur={handleSubjectBlur}
                          // maxLength={50}
                          placeholder={currentLang?.WriteMessagePage?.Subject}
                        // onKeyDown={(e) => {
                        //   if (e.key === "Enter") {
                        //     e.preventDefault();
                        //     handlePhotoSendValidation();
                        //   }
                        // }}
                        //   errorMessage={errors?.subject}
                        />
                        {creditBalance?.IsEmojiEnabled === true && (
                          <span
                            className="position-absolute end-0 top-50 translate-middle-y me-3 fs-5 animated-emoji"
                            onClick={() => handleIconClick("subject")}
                          >
                            😊
                          </span>
                        )}
                      </div>
                      <div className="text-danger fw-700 fs-6 mb-20px mt-1">
                        {errors && errors["subject"]}
                      </div>
                      {isSubjectIconPickerOpen && isSubjectFocused && (
                        <div
                          className="dropdown-menu show p-2 overflow-auto"
                          ref={emojiPickerRef} tabIndex={-1}
                          onMouseDown={(e) => {
                            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                            if (isIOS) {
                              e.preventDefault(); // Prevent input blur only on iOS
                            }
                          }}
                        >
                          <EmojiPicker
                            onEmojiSelect={(emoji) =>
                              handleEmojiSelectPhoto(emoji, "subject")
                            }
                            onClose={() => setIsSubjectIconPickerOpen(false)}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {/* File Input */}
                  <div className="mb-2">
                    <input
                      type="file"
                      name="file"
                      id="ImageUpload"
                      className="form-control"
                      accept=".jpg,.jpeg,.png"
                      onChange={handleImageChange}
                    />
                    {errors?.file && (
                      <div className="text-danger fw-700 fs-6 mt-1">
                        {errors?.file}
                      </div>
                    )}
                  </div>
                  <div className="form-text fs-5 text-default-black">
                    <span className="text-danger">*</span> {currentLang?.WriteMessagePage?.ImgContent}
                  </div>

                  {/* Image Preview */}
                  {selectedImage && (
                    <div className="mt-1 text-center">
                      {/* Container to hold the image */}
                      <div
                        className="d-inline-block position-relative overflow-visible"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "60px",
                          marginBottom: "80px", // Add margin to move the image down
                        }}
                      >
                        {/* Rotate/Flip applied to the image */}
                        <div
                          style={{
                            transform: `rotate(${rotation}deg)`, // Apply rotation dynamically
                            transition: "transform 0.3s ease", // Smooth transition for rotation
                            transformOrigin: "center", // Rotate around the center of the image
                          }}
                        >
                          <img
                            src={selectedImage}
                            alt="Preview"
                            className="img-fluid"
                            style={{
                              objectFit: "contain", // Ensure the image scales to fit without clipping
                              maxWidth: "300px", // Set a maximum width
                              maxHeight: "200px", // Set a maximum height
                              width: "auto", // Adjust width dynamically
                              height: "auto", // Adjust height dynamically
                            }}
                          />
                        </div>
                      </div>

                      {/* Rotate Buttons */}
                      <div className="mt-3">
                        <button
                          className="btn btn-danger mrl-10 fs-14"
                          onClick={() => rotateImage("left")}
                        >
                          <i className="fa-solid fa-rotate-left"></i>
                        </button>
                        <button
                          className="btn btn-danger mrl-10 fs-14"
                          onClick={() => rotateImage("flip")}
                        >
                          <i className="fa-solid fa-repeat"></i>
                        </button>
                        <button
                          className="btn btn-danger mrl-10 fs-14"
                          onClick={() => rotateImage("right")}
                        >
                          <i className="fa-solid fa-rotate-right"></i>
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="mb-3 position-relative"></div>

                  <div className="d-flex flex-column flex-md-row justify-content-between">
                    <div>
                      <button
                        className="btn button-success me-2 font-size-14 mb-2"
                        onClick={handlePhotoSendValidation}
                      >
                        <i className="fa-regular fa-paper-plane me-1"></i>{currentLang?.buttons?.Send}
                      </button>
                      <button
                        className="btn btn-grey font-size-14 mb-2"
                        onClick={handlePhotoReset}
                      >
                        <i className="fa-solid fa-arrow-rotate-left me-1"></i>
                        {currentLang?.buttons?.Reset}
                      </button>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-lg-12">
                      <p className="fs-5 no-expectation-text">
                        <strong className="text-danger">*</strong> {currentLang?.Photo_Notice_Content}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {/*--------------------------------- Send E-card Tab- Content Section -------------------------------------*/}
              {activeTab === "ecard" && (// Checks if the active tab is "ecard"              
                <EcardGallery EcardInmateID={EcardInmateID} />)}

              {/* ------- Popup for Send Message - Confirmation -------------- */}
              <ConfirmationModal
                show={SendMessageConfirmation}
                onHide={handleCancelMessage}
                onConfirm={handleMessageSentConfirm}
                title={currentLang?.Message}
                messageHTML={
                  shouldDisplayHTMLMessage && message.messageEmojiCost > 0
                    ? `${currentLang?.InboxPopContent?.Send_MSG_Confirm} </br>
                       ${currentLang?.Total_Cost} <strong style="color:${message.messageCost > 0 ? "#4a9a93" : "#C8605E"
                    };">$${message.messageCost}</strong> 
                       (${currentLang?.Message_Cost} <strong style="color:${creditBalance?.FacilityMessageCost > 0
                      ? "#4a9a93"
                      : "#C8605E"
                    };">$${creditBalance?.FacilityMessageCost.toFixed(
                      2
                    )}</strong> 
                       + ${currentLang?.Emoji_Cost} <strong style="color:${message.messageEmojiCost > 0 ? "#4a9a93" : "#C8605E"
                    };">$${message.messageEmojiCost}</strong>)`
                    : `${currentLang?.InboxPopContent?.Send_MSG_Confirm}`
                }
                message={
                  (message.messageEmojiCost > 0
                    ? `\n${currentLang?.Total_Cost} $${message.messageCost
                    } (${currentLang?.Message_Cost} $${creditBalance?.FacilityMessageCost.toFixed(
                      2
                    )} + ${currentLang?.Emoji_Cost} $${message.messageEmojiCost})`
                    : "") + `${currentLang?.InboxPopContent?.Send_MSG_Confirm}`
                }
                closeButton={false}
                onconfirmname={currentLang?.buttons?.Yes}
                oncancelname={currentLang?.buttons?.No}
              />
              {/* ------- Popup for Send photo - Confirmation -------------- */}
              <ConfirmationModal
                show={SendPhotoConfirmation}
                onHide={handleCancelMessage}
                onConfirm={handlePhotoSend}
                title={currentLang?.Message}
                messageHTML={
                  shouldDisplayHTMLMessage && photo?.photoEmojiCost > 0
                    ? `${currentLang?.InboxPopContent?.Send_MSG_Confirm} </br>
                     ${currentLang?.Total_Cost} <b style="color:${photo.photoCost > 0 ? "#4a9a93" : "#C8605E "
                    };">$${photo?.photoCost}</b> 
                       (${currentLang?.Photo_Cost} <b style="color:${creditBalance?.FacilityPhotoCost > 0
                      ? "#4a9a93"
                      : "#C8605E"
                    };">$${creditBalance?.FacilityPhotoCost.toFixed(2)}</b> 
                       + ${currentLang?.Emoji_Cost} <b style="color:${photo?.photoEmojiCost > 0 ? "#4a9a93" : "#C8605E"
                    };">$${photo?.photoEmojiCost}</b>)`
                    : null
                }
                message={currentLang?.InboxPopContent?.Send_MSG_Confirm}
                closeButton={false}
                onconfirmname={currentLang?.buttons?.Yes}
                oncancelname={currentLang?.buttons?.No}
              />
              {/* ------- Popup for Send Ecard - Confirmation -------------- */}
              <ConfirmationModal
                show={SendEcardConfirmation}
                onHide={() => {
                  setSendEcardConfirmation(false);
                }}
                onConfirm={handleEcardSend}
                title={currentLang?.Message}
                messageHTML={
                  shouldDisplayHTMLMessage && ecard?.totalEmojiCost > 0
                    ? `${currentLang?.InboxPopContent?.Send_MSG_Confirm} </br>
                     ${currentLang?.Total_Cost} <b style="color:${ecard?.totalEcardCost > 0 ? "#4a9a93" : "#C8605E "
                    };">$${ecard?.totalEcardCost}</b> 
                       (${currentLang?.ECard_Cost} <b style="color:${creditBalance?.FacilityEcardCost > 0
                      ? "#4a9a93"
                      : "#C8605E"
                    };">$${creditBalance?.FacilityEcardCost.toFixed(2)}</b> 
                       + ${currentLang?.Emoji_Cost} <b style="color:${ecard?.totalEmojiCost > 0 ? "#4a9a93" : "#C8605E"
                    };">$${ecard?.totalEmojiCost}</b>)`
                    : null
                }
                // messageHTML={
                //   shouldDisplayHTMLMessage && ecard?.totalEmojiCost > 0
                //     ? `<h6>Total Cost: ${
                //         " $" + ecard?.totalEcardCost
                //       } (Ecard Cost:  ${
                //         " $" + creditBalance?.FacilityEcardCost.toFixed(2)
                //       } + Emoji Cost:  ${" $" + ecard?.totalEmojiCost})</h6>`
                //     : null
                // }
                message={currentLang?.InboxPopContent?.Send_MSG_Confirm}
                closeButton={false}
                onconfirmname={currentLang?.buttons?.Yes}
                oncancelname={currentLang?.buttons?.No}
              />
              {/* --------- Popup for COD message warning -------------------- */}
              <ConfirmationModal
                show={showCODPopup}
                // onHide={handleCancelMessage}
                onConfirm={handleRedirectPurchaseCredit}
                title={currentLang?.Message}
                message={currentLang?.InboxPopContent?.Send_COD_Msg}
                showCancelButton={false} // Pass 'false' to hide the "No" button
                messageColor="#FF7F7F"
                size={"lg"}
                onconfirmname={currentLang?.buttons?.OK}
                closeButton={false}
              />
            </div>
          </div>
          {loader}
        </div>
        {/* Modal Popup for redirect purchase credit */}
        <ConfirmationModal
          show={isCreditamountModal}
          // onHide={handleCancelMessage}
          onConfirm={handleClickRedirect}
          title={currentLang?.Message}
          message={msgCreditamount}
          showCancelButton={false} // Pass 'false' to hide the "No" button
          messageColor="#FF7F7F"
          size={"lg"}
          onconfirmname={currentLang?.buttons?.OK}
          closeButton={false}
        />

        <ConfirmationModal
          show={IsHasEmojiPermission}
          onHide={handleCancelEmojiPermission}
          onConfirm={handleClickEmojiPermission}
          title={currentLang?.Message}
          message={currentLang?.InboxPopContent?.NO_Emojis_Access}
          showCancelButton={true}
          onconfirmname={currentLang?.buttons?.Yes}
          closeButton={false}
        />

        <ConfirmationModal
          show={isPaymentMsg}
          onHide={() => setIsPaymentMsg(false)}
          onConfirm={() => setIsPaymentMsg(false)}
          title={currentLang?.Message}
          message={paymentMsg}
          showCancelButton={false}
          onconfirmname={currentLang?.buttons?.OK}
        />

        {/* Modal Popup for Emoji Permission */}
        <ConfirmationModal
          show={IsHasMsgEmojiPermission}
          onHide={() => setIsHasMsgEmojiPermission(false)} // Correctly passes the close handler
          onConfirm={handleClickMsgEmojiPermission}
          title={currentLang?.Message}
          message={currentLang?.InboxPopContent?.NO_Emojis_Access_Subject}
        />

        {/* Modal Popup for Restricted Keywords */}
        <ConfirmationModal
          show={keywordPopup}
          onHide={() => setKeywordPopup(false)} // Correctly passes the close handler
          onConfirm={() => setKeywordPopup(false)}
          title={currentLang?.Message}
          message={foundKeyword}
          onconfirmname={currentLang?.buttons?.OK}
          closeButton={false}
          showCancelButton={false}
        />

        <ConfirmationModal
          show={sendEmojiRejectPopup}
          closeButton={false}
          onConfirm={handleSendEmojiRejectPopupClose}
          onHide={handleSendEmojiRejectPopupClose}
          title={currentLang?.Message}
          showCancelButton={false}
          size={"lg"}
          messageColor="#c8605e"
          onconfirmname={currentLang?.buttons?.OK}
          message={currentLang?.InboxPopContent?.NO_Longer_Emojis_Access}
        />
      </div>
    </>
  );
};

export default React.memo(WriteMessage);
